/**
 * Autocomplete data for Lead Finder filters
 *
 * INDUSTRIES Source: Pipeline Labs (https://pipelinelabs-dos.pages.dev/)
 * Last updated: 2025-12-04
 * - Industries: 148 LinkedIn-standard options (matches Pipeline Labs exactly)
 *
 * COUNTRIES Source: Pipeline Labs/Apify Actor (extracted from API validation)
 * Last updated: 2025-12-26
 * - Countries: 237 options - MUST match exact values accepted by the actor
 *
 * PEAKY LEADS Source: Peaky Leads API (https://leads-scraper.work.gd)
 * Last updated: 2025-11-13
 * - States/Regions: 4128 options
 */

// Pipeline Labs Industries (148 options) - LinkedIn-standard industry taxonomy
export const INDUSTRIES = [
  "Accounting",
  "Agriculture",
  "Airlines/Aviation",
  "Alternative Dispute Resolution",
  "Animation",
  "Apparel & Fashion",
  "Regenerative Design",
  "Armed Forces",
  "Photography",
  "Museums",
  "Professional Training and Coaching",
  "Technical and Vocational Training",
  "Primary and Secondary Education",
  "Entertainment Providers",
  "Circuses and Magic Shows",
  "Professional Organizations",
  "Professional Services",
  "Savings Institutions",
  "Secretarial Schools",
  "Insurance and Employee Benefit Funds",
  "International Trade and Development",
  "Insurance Agencies and Brokerages",
  "Financial Services",
  "Insurance Carriers",
  "Investment Advice",
  "Funds and Trusts",
  "Fundraising",
  "Insurance",
  "Fruit and Vegetable Preserves Manufacturing",
  "Food and Beverage Manufacturing",
  "Meat Products Manufacturing",
  "Dairy Product Manufacturing",
  "Food and Beverage Services",
  "Beverage Manufacturing",
  "Food and Beverage Retail",
  "Distilleries",
  "Breweries",
  "Sugar and Confectionery Product Manufacturing",
  "Air, Water, and Waste Program Management",
  "Seafood Product Manufacturing",
  "Claims Adjusting, Actuarial Services",
  "Civic and Social Organizations",
  "Administration of Justice",
  "Wineries",
  "Nursing Homes and Residential Care Facilities",
  "Medical and Diagnostic Laboratories",
  "Medical Equipment Manufacturing",
  "Home Health Care Services",
  "Hospitals and Health Care",
  "Family Planning Centers",
  "Medical Practices",
  "Mental Health Care",
  "Hospitals",
  "Bed-and-Breakfasts, Hostels, Homestays",
  "Pharmaceutical Manufacturing",
  "Bars, Taverns, and Nightclubs",
  "Human Resources Services",
  "Staffing and Recruiting",
  "Hotels and Motels",
  "Public Safety",
  "Hospitality",
  "Caterers",
  "Desktop Computing Software Products",
  "IT System Custom Software Development",
  "IT System Installation and Disposal",
  "Digital Accessibility Services",
  "IT Services and IT Consulting",
  "IT System Design Services",
  "Embedded Software Products",
  "IT System Data Services",
  "Graphic Design",
  "Data Infrastructure and Analytics",
  "Technology, Information and Media",
  "Translation and Localization",
  "Telephone Call Centers",
  "Alternative Dispute Resolution",
  "Legal Services",
  "Law Enforcement",
  "Courts of Law",
  "Law Practice",
  "Transportation, Logistics, Supply Chain and Storage",
  "Abrasives and Nonmetallic Minerals Manufacturing",
  "Transportation Equipment Manufacturing",
  "Wholesale Import and Export",
  "Sightseeing Transportation",
  "Taxi and Limousine Services",
  "Transportation Programs",
  "Urban Transit Services",
  "Truck Transportation",
  "Engines and Power Transmission Equipment Manufacturing",
  "Electric Lighting Equipment Manufacturing",
  "Clay and Refractory Products Manufacturing",
  "Climate Technology Product Manufacturing",
  "Communications Equipment Manufacturing",
  "Construction Hardware Manufacturing",
  "Electrical Equipment Manufacturing",
  "Cutlery and Handtool Manufacturing",
  "Footwear Manufacturing",
  "Measuring and Control Instrument Manufacturing",
  "Metal Valve, Ball, and Roller Manufacturing",
  "Office Furniture and Fixtures Manufacturing",
  "Metalworking Machinery Manufacturing",
  "Motor Vehicle Parts Manufacturing",
  "Mattress and Blinds Manufacturing",
  "Motor Vehicle Manufacturing",
  "Machinery Manufacturing",
  "Manufacturing",
  "Turned Products and Fastener Manufacturing",
  "Soap and Cleaning Product Manufacturing",
  "Spring and Wire Product Manufacturing",
  "Women's Handbag Manufacturing",
  "Wood Product Manufacturing",
  "Marketing Services",
  "Market Research",
  "Artists and Writers",
  "Blogs",
  "Fabricated Metal Products",
  "Media and Telecommunications",
  "Retail Books and Printed News",
  "Social Networking Platforms",
  "Coal Mining",
  "Periodical Publishing",
  "Newspaper Publishing",
  "Writing and Editing",
  "Printing Services",
  "Electric Power Transmission, Control, and Distribution",
  "Fossil Fuel Electric Power Generation",
  "Geothermal Electric Power Generation",
  "Oil and Coal Product Manufacturing",
  "Nuclear Electric Power Generation",
  "Hydroelectric Power Generation",
  "Natural Gas Distribution",
  "Natural Gas Extraction",
  "Oil Extraction",
  "Plastics and Rubber Product Manufacturing",
  "Packaging and Containers Manufacturing",
  "Freight and Package Transportation",
  "Waste Treatment and Disposal",
  "Plastics Manufacturing",
  "Religious Institutions",
  "Industry Associations",
  "Performing Arts",
  "Think Tanks",
  "Community Development and Urban Planning",
  "Nonresidential Building Construction",
  "Leasing Non-residential Real Estate",
  "Housing and Community Development",
  "Leasing Residential Real Estate",
  "Real Estate Agents and Brokers",
  "Construction",
  "Interior Design",
  "Real Estate",
  "Reupholstery and Furniture Repair",
  "Vehicle Repair and Maintenance",
  "Repair and Maintenance",
  "Fashion Accessories Manufacturing",
  "Online and Mail Order Retail",
  "Apparel Manufacturing",
  "Building Construction",
  "Consumer Goods Rental",
  "Restaurants",
  "Retail Recyclable Materials & Used Merchandise",
  "Retail Health and Personal Care Products",
  "Retail Office Supplies and Gifts",
  "Retail Luxury Goods and Jewelry",
  "Retail Musical Instruments",
  "Retail Office Equipment",
  "Retail Motor Vehicles",
  "Retail Pharmacies",
  "Retail Groceries",
  "Wholesale Hardware, Plumbing, Heating Equipment",
  "Wholesale Photography Equipment and Supplies",
  "Wholesale Furniture and Home Furnishings",
  "Wholesale Luxury Goods and Jewelry",
  "Wholesale Motor Vehicles and Parts",
  "Wholesale Recyclable Materials",
  "Wholesale Raw Farm Products",
  "Wholesale Paper Products",
  "Wholesale Machinery",
  "Commercial and Industrial Equipment Rental",
  "Environmental Quality Programs",
  "Emergency and Relief Services",
  "Equipment Rental Services",
  "Environmental Services",
  "Engineering Services",
  "Community Services",
  "Consumer Services",
  "Design Services",
  "Individual and Family Services",
  "Executive Search Services",
  "Health and Human Services",
  "Information Services",
  "Facilities Services",
  "Janitorial Services",
  "Executive Offices",
  "Household Services",
  "Events Services",
  "Water, Waste, Steam, and Air Conditioning Services",
  "Public Relations and Communications Services",
  "Vocational Rehabilitation Services",
  "Surveying and Mapping Services",
  "Strategic Management Services",
  "Recreational Facilities",
  "Temporary Help Services",
  "Research Services",
  "Dance Companies",
  "Health, Wellness & Fitness",
  "Museums, Historical Sites, and Zoos",
  "Utilities Administration",
  "Amusement Parks and Arcades",
  "Zoos and Botanical Gardens",
  "Travel Arrangements",
  "Historical Sites",
  "Utilities",
  "Renewable Energy Semiconductor Manufacturing",
  "Building Structure and Exterior Contractors",
  "Highway, Street, and Bridge Construction",
  "Non-profit Organization Management",
  "Leisure, Travel & Tourism",
  "Building Materials",
  "Luxury Goods & Jewelry",
  "Furniture",
  "Online Media",
  "Aviation and Aerospace Component Manufacturing",
  "Education Administration Programs",
  "Cosmetology and Barber Schools",
  "Space Research and Technology",
  "E-Learning Providers",
  "Higher Education",
  "Flight Training",
  "Language Schools",
  "Fine Arts Schools",
  "Education",
  "Online Audio and Video Media",
  "Movies and Sound Recording",
  "Movies, Videos, and Sound",
  "Sheet Music Publishing",
  "Farming, Ranching, Forestry",
  "Theater Companies",
  "Sound Recording",
  "Musicians",
  "Farming",
  "Ranching and Fisheries",
  "Credit Intermediation",
  "Collection Agencies",
  "Forestry and Logging",
  "Capital Markets",
  "Horticulture",
  "Accounting",
  "Ranching",
  "Banking",
  "Venture Capital and Private Equity Principals",
  "Animal Feed Manufacturing",
  "Baked Goods Manufacturing",
  "Philanthropic Fundraising Services",
  "Specialty Trade Contractors",
  "Investment Management",
  "Investment Banking",
  "Pension Funds",
  "Loan Brokers",
  "Government Relations Services",
  "Government Administration",
  "Political Organizations",
  "International Affairs",
  "Conservation Programs",
  "Economic Programs",
  "Housing Programs",
  "Fire Protection",
  "Postal Services",
  "Water Supply and Irrigation Systems",
  "Steam and Air-Conditioning Supply",
  "Public Assistance Programs",
  "Correctional Institutions",
  "Alternative Medicine",
  "Ambulance Services",
  "Waste Collection",
  "Chiropractors",
  "Dentists",
  "Physical, Occupational and Speech Therapists",
  "Services for the Elderly and Disabled",
  "Accommodation and Food Services",
  "Wellness and Fitness Services",
  "Outpatient Care Centers",
  "Veterinary Services",
  "Public Health",
  "Optometrists",
  "Physicians",
  "Computers and Electronics Manufacturing",
  "Business Intelligence Platforms",
  "Computer Hardware Manufacturing",
  "Data Security Software Products",
  "Animation and Post-production",
  "Computer and Network Security",
  "Computer Networking Products",
  "Climate Data and Analytics",
  "Computer Games",
  "Outsourcing and Offshoring Consulting",
  "IT System Operations and Maintenance",
  "Technology, Information and Internet",
  "Mobile Computing Software Products",
  "IT System Testing and Evaluation",
  "IT System Training and Support",
  "Internet Marketplace Platforms",
  "Software Development",
  "Robotics Engineering",
  "Shuttles and Special Needs Transportation Services",
  "Interurban and Rural Bus Services",
  "Ground Passenger Transportation",
  "School and Employee Bus Services",
  "Pipeline Transportation",
  "Maritime Transportation",
  "Rail Transportation",
  "Fisheries",
  "Legislative Offices",
  "Agriculture, Construction, Mining Machinery Manufacturing",
  "Appliances, Electrical, and Electronics Manufacturing",
  "Artificial Rubber and Synthetic Fiber Manufacturing",
  "Boilers, Tanks, and Shipping Container Manufacturing",
  "Architectural and Structural Metal Manufacturing",
  "Audio and Video Equipment Manufacturing",
  "Alternative Fuel Vehicle Manufacturing",
  "Accessible Hardware Manufacturing",
  "Automation Machinery Manufacturing",
  "HVAC and Refrigeration Equipment Manufacturing",
  "Furniture and Home Furnishings Manufacturing",
  "Glass, Ceramics and Concrete Manufacturing",
  "Lime and Gypsum Products Manufacturing",
  "Industrial Machinery Manufacturing",
  "Household Appliance Manufacturing",
  "Leather Product Manufacturing",
  "Glass Product Manufacturing",
  "Fuel Cell Manufacturing",
  "Renewable Energy Equipment Manufacturing",
  "Paint, Coating, and Adhesive Manufacturing",
  "Paper and Forest Product Manufacturing",
  "Personal Care Product Manufacturing",
  "Railroad Equipment Manufacturing",
  "Semiconductor Manufacturing",
  "Primary Metal Manufacturing",
  "Robot Manufacturing",
  "Shipbuilding",
  "Broadcast Media Production and Distribution",
  "Magnetic and Optical Media Manufacturing",
  "Book and Periodical Publishing",
  "Internet Publishing",
  "Business Content",
  "Media Production",
  "Book Publishing",
  "Internet News",
  "Libraries",
  "Biomass Electric Power Generation",
  "Wholesale Metals and Minerals",
  "Nonmetallic Mineral Mining",
  "Nanotechnology Research",
  "Electric Power Generation",
  "Metal Treatments",
  "Metal Ore Mining",
  "Non-profit Organizations",
  "Mining",
  "Wholesale Petroleum and Petroleum Products",
  "Renewable Energy Power Generation",
  "Solar Electric Power Generation",
  "Services for Renewable Energy",
  "Wind Electric Power Generation",
  "Oil, Gas, and Mining",
  "Biotechnology Research",
  "Holding Companies",
  "Oil and Gas",
  "Commercial and Service Industry Machinery Manufacturing",
  "Accessible Architecture and Design",
  "Building Finishing Contractors",
  "Building Equipment Contractors",
  "Rubber Products Manufacturing",
  "Architecture and Planning",
  "Civil Engineering",
  "Commercial and Industrial Machinery Maintenance",
  "Electronic and Precision Equipment Maintenance",
  "Footwear and Leather Goods Repair",
  "Real Estate and Equipment Rental Services",
  "Residential Building Construction",
  "Utility System Construction",
  "Wholesale Building Materials",
  "Subdivision of Land",
  "Trusts and Estates",
  "Retail Appliances, Electrical, and Electronic Equipment",
  "Retail Building Materials and Garden Equipment",
  "Retail Furniture and Home Furnishings",
  "Retail Apparel and Fashion",
  "Retail Art Supplies",
  "Retail Art Dealers",
  "Retail Florists",
  "Retail Gasoline",
  "Retail",
  "Wholesale Appliances, Electrical, and Electronics",
  "Wholesale Chemical and Allied Products",
  "Wholesale Apparel and Sewing Supplies",
  "Wholesale Computer Equipment",
  "Wholesale Drugs and Sundries",
  "Smart Meter Manufacturing",
  "Warehousing and Storage",
  "Wholesale Footwear",
  "Wholesale",
  "Security Guards and Patrol Services",
  "Securities and Commodity Exchanges",
  "Security and Investigations",
  "Security Systems Services",
  "Administrative and Support Services",
  "Business Consulting and Services",
  "Child Day Care Services",
  "Advertising Services",
  "Blockchain Services",
  "Laundry and Drycleaning Services",
  "Personal and Laundry Services",
  "Personal Care Services",
  "Office Administration",
  "Operations Consulting",
  "Landscaping Services",
  "Public Policy Offices",
  "Mobile Food Services",
  "Pet Services",
  "Performing Arts and Spectator Sports",
  "Gambling Facilities and Casinos",
  "Golf Courses and Country Clubs",
  "Sporting Goods Manufacturing",
  "Sports Teams and Clubs",
  "Skiing Facilities",
  "Mobile Gaming Apps",
  "Spectator Sports",
  "Racetracks",
  "Radio and Television Broadcasting",
  "Cable and Satellite Programming",
  "Sports and Recreation Instruction",
  "Satellite Telecommunications",
  "Telecommunications Carriers",
  "Textile Manufacturing",
  "Tobacco Manufacturing",
  "Telecommunications",
  "Wireless Services",
  "Accommodation Services",
  "Government Relations",
  "Education Management",
  "Aviation & Aerospace",
  "Dairy",
  "Defense & Space",
  "Veterinary",
  "E-learning",
  "Design",
  "Household and Institutional Furniture Manufacturing"
];


export const COUNTRIES = [
  "Afghanistan",
  "Aland Islands",
  "Albania",
  "Algeria",
  "American Samoa",
  "Andorra",
  "Angola",
  "Anguilla",
  "Antigua and Barbuda",
  "Argentina",
  "Armenia",
  "Aruba",
  "Australia",
  "Austria",
  "Azerbaijan",
  "Bahrain",
  "Bangladesh",
  "Barbados",
  "Belarus",
  "Belgium",
  "Belize",
  "Benin",
  "Bermuda",
  "Bhutan",
  "Bolivia",
  "Bonaire, Sint Eustatius and Saba",
  "Bosnia and Herzegovina",
  "Botswana",
  "Brazil",
  "British Virgin Islands",
  "Brunei",
  "Bulgaria",
  "Burkina Faso",
  "Burundi",
  "Cambodia",
  "Cameroon",
  "Canada",
  "Cape Verde",
  "Caribbean Netherlands",
  "Cayman Islands",
  "Central African Republic",
  "Chad",
  "Chile",
  "China",
  "Cocos (Keeling) Islands",
  "Colombia",
  "Congo",
  "Congo - Kinshasa",
  "Cook Islands",
  "Costa Rica",
  "Cote d'Ivoire",
  "Croatia",
  "Cuba",
  "Curacao",
  "Cyprus",
  "Czech Republic",
  "Czechia",
  "Democratic Republic of the Congo",
  "Denmark",
  "Djibouti",
  "Dominica",
  "Dominican Republic",
  "Ecuador",
  "Egypt",
  "El Salvador",
  "Equatorial Guinea",
  "Eritrea",
  "Estonia",
  "Ethiopia",
  "Faroe Islands",
  "Federated States of Micronesia",
  "Fiji",
  "Finland",
  "France",
  "French Guiana",
  "French Polynesia",
  "Gabon",
  "Georgia",
  "Germany",
  "Ghana",
  "Gibraltar",
  "Greece",
  "Greenland",
  "Grenada",
  "Guadeloupe",
  "Guam",
  "Guatemala",
  "Guernsey",
  "Guinea",
  "Guinea-Bissau",
  "Guyana",
  "Haiti",
  "Honduras",
  "Hong Kong",
  "Hungary",
  "Iceland",
  "India",
  "Indonesia",
  "Iran",
  "Iraq",
  "Ireland",
  "Isle of Man",
  "Israel",
  "Italy",
  "Jamaica",
  "Japan",
  "Jersey",
  "Jordan",
  "Kazakhstan",
  "Kenya",
  "Kosovo",
  "Kuwait",
  "Kyrgyzstan",
  "Laos",
  "Latvia",
  "Lebanon",
  "Lesotho",
  "Liberia",
  "Libya",
  "Liechtenstein",
  "Lithuania",
  "Luxembourg",
  "Macau",
  "Macedonia (FYROM)",
  "Madagascar",
  "Malawi",
  "Malaysia",
  "Maldives",
  "Mali",
  "Malta",
  "Marshall Islands",
  "Martinique",
  "Mauritania",
  "Mauritius",
  "Mayotte",
  "Mexico",
  "Micronesia",
  "Moldova",
  "Monaco",
  "Mongolia",
  "Montenegro",
  "Montserrat",
  "Morocco",
  "Mozambique",
  "Myanmar (Burma)",
  "Namibia",
  "Nepal",
  "Netherlands",
  "New Caledonia",
  "New Zealand",
  "Nicaragua",
  "Niger",
  "Nigeria",
  "Northern Mariana Islands",
  "Norway",
  "Oman",
  "Pakistan",
  "Palau",
  "Panama",
  "Papua New Guinea",
  "Paraguay",
  "Peru",
  "Philippines",
  "Poland",
  "Portugal",
  "Puerto Rico",
  "Qatar",
  "Republic of Indonesia",
  "Republic of the Congo",
  "Republic of the Union of Myanmar",
  "Reunion",
  "Romania",
  "Russia",
  "Rwanda",
  "Saint Barthelemy",
  "Saint Kitts and Nevis",
  "Saint Lucia",
  "Saint Martin",
  "Saint Vincent and the Grenadines",
  "Samoa",
  "San Marino",
  "Saudi Arabia",
  "Senegal",
  "Serbia",
  "Seychelles",
  "Sierra Leone",
  "Singapore",
  "Sint Maarten",
  "Slovakia",
  "Slovenia",
  "Solomon Islands",
  "Somalia",
  "South Africa",
  "South Korea",
  "South Sudan",
  "Spain",
  "Sri Lanka",
  "St. Barthelemy",
  "St. Lucia",
  "St. Martin",
  "Sudan",
  "Suriname",
  "Svalbard and Jan Mayen",
  "Swaziland",
  "Sweden",
  "Switzerland",
  "Syria",
  "Taiwan",
  "Tajikistan",
  "Tanzania",
  "Thailand",
  "The Bahamas",
  "The Gambia",
  "Timor-Leste",
  "Togo",
  "Trinidad & Tobago",
  "Trinidad and Tobago",
  "Tunisia",
  "Turkey",
  "Turkmenistan",
  "Turks and Caicos Islands",
  "U.S. Virgin Islands",
  "Uganda",
  "Ukraine",
  "United Arab Emirates",
  "United Kingdom",
  "United States",
  "Uruguay",
  "Uzbekistan",
  "Vanuatu",
  "Vatican City",
  "Venezuela",
  "Vietnam",
  "Yemen",
  "Zambia",
  "Zimbabwe"
];

export const REGIONS = [
  "California",
  "New York",
  "Ontario",
  "Salzburg",
  "Šiauliai District Municipality",
  "Tataouine Governorate",
  "East",
  "Prague",
  "Odranci Municipality",
  "Boumérdès Province",
  "Cacheu Region",
  "Manicaland",
  "Nord-Trøndelag",
  "Vsetín District",
  "Borsod-Abaúj-Zemplén County",
  "Narok County",
  "Baie Lazare",
  "Most District",
  "Poole",
  "Burgenland",
  "Sakon Nakhon",
  "Saint Thomas Lowland Parish",
  "Saint Petersburg",
  "Harari Region",
  "Ards",
  "Għarb",
  "Tocantins",
  "Nouakchott-Sud Region",
  "Thakurgaon District",
  "Karaganda Region",
  "Navoiy Region",
  "Rankovce Municipality",
  "South West Community Development Council",
  "North Maluku",
  "Tigray Region",
  "Bắc Giang",
  "Kadiogo Province",
  "Béjaïa Province",
  "Gorje Municipality",
  "Haa District",
  "Črnomelj Municipality",
  "Achaea Regional Unit",
  "Conwy County Borough",
  "Mashonaland West Province",
  "Bulacan",
  "Taza Province",
  "Prebold Municipality",
  "Ig Municipality",
  "Cuanza Sul",
  "Mwanza District",
  "Kaposvár",
  "Bel Ombre",
  "Nuqat al Khams",
  "Dornogovi Province",
  "Bengkulu",
  "Vermont",
  "Radoviš Municipality",
  "Kaolack",
  "Koulpélogo Province",
  "Province of Asturias",
  "Skrapar District",
  "Archipelago of Saint Andréws, Providence and Saint Catalina",
  "Saint David Parish",
  "Swindon",
  "Yaren District",
  "Jarvis Island",
  "Mosteiros",
  "Mureș County",
  "Haut-Ogooué Province",
  "Edirne Province",
  "Kaffrine",
  "Seoul",
  "Nakhon Pathom",
  "Apure",
  "Takhar",
  "Samara Oblast",
  "Gloucestershire",
  "Thuringia",
  "Badajoz Province",
  "Lamu County",
  "Edo State",
  "Alsunga Municipality",
  "Alytus District Municipality",
  "Domžale Municipality",
  "Miklavž na Dravskem Polju Municipality",
  "Mila Province",
  "Slovenska Bistrica Municipality",
  "Yaracuy",
  "Rogatec Municipality",
  "Muranga County",
  "Sucumbíos Province",
  "Khelvachauri Municipality",
  "Boaco Department",
  "Balakan District",
  "Tarija Department",
  "Isla de la Juventud",
  "Mont Fleuri",
  "Lanao del Sur",
  "Nevşehir Province",
  "Plzeň-North District",
  "Sagaing Region",
  "Brest Region",
  "Kampot Province",
  "Moyo District",
  "Ifrane Province",
  "Bridgend County Borough",
  "Orkney Islands",
  "Penama",
  "Poitou-Charentes",
  "Fujairah",
  "Sidi Bouzid Governorate",
  "London Borough of Redbridge",
  "Guarda District",
  "Jessore District",
  "Araba / Álava",
  "Canton of Neuchâtel",
  "City of Leicester",
  "Atacama Region",
  "Gnaviyani Atoll",
  "Bafatá",
  "San Juan Province",
  "Guelma Province",
  "Cantemir District",
  "Rivas Department",
  "Mogilev Region",
  "Porto District",
  "Loški Potok Municipality",
  "Collines Department",
  "North Sinai Governorate",
  "Béni-Mellal Province",
  "Huila Department",
  "Al Mahwit Governorate",
  "Cascade",
  "West New Britain Province",
  "Lunda Sul Province",
  "Anibare District",
  "Zanzibar Central/South Region",
  "Mayaguana District",
  "Beijing",
  "Al Madinah Region",
  "Podvelka Municipality",
  "Vallée du Bandama District",
  "Vipava Municipality",
  "Eastern Region",
  "Copán Department",
  "Panjshir",
  "South Tyrol",
  "Palencia Province",
  "Capital Region of Denmark",
  "Želino Municipality",
  "Duplek Municipality",
  "Mislinja Municipality",
  "Ternopil Oblast",
  "Central Governorate",
  "Canary Islands",
  "Mayo-Kebbi Est Region",
  "Lower Normandy",
  "Sul Province",
  "Ikšķile Municipality",
  "Totonicapán Department",
  "Commewijne District",
  "Bundibugyo District",
  "Ukmergė District Municipality",
  "Fars Province",
  "Caazapá",
  "Province of Ávila",
  "Rajasthan",
  "Mono Department",
  "Obock Region",
  "Rokiškis District Municipality",
  "Aksaray Province",
  "Wele-Nzas Province",
  "Puttalam District",
  "Fgura",
  "Komen Municipality",
  "Sigulda Municipality",
  "Sotavento Islands",
  "Indiana",
  "Saint John Parish",
  "Butaleja District",
  "Armavir Region",
  "Kasserine Governorate",
  "Nevis",
  "Český Krumlov District",
  "Kabarole District",
  "Ulsan",
  "Brakna Region",
  "Mahakali Zone",
  "Masally District",
  "Syunik Province",
  "Saint Philip Parish",
  "Khizi District",
  "Auce Municipality",
  "Radviliškis District Municipality",
  "Żabbar",
  "Rundāle Municipality",
  "County Kerry",
  "Plateau Department",
  "Frýdek-Místek District",
  "Vest-Agder",
  "Leiria District",
  "Brussels-Capital Region",
  "Beverīna Municipality",
  "Calderdale",
  "Sichuan",
  "Preddvor Municipality",
  "Pavlodar Region",
  "South Jeolla Province",
  "Gafsa Governorate",
  "Guéra Region",
  "Naxxar",
  "Chanthaburi",
  "Khanty-Mansi Autonomous Okrug",
  "Soroca District",
  "Bomet County",
  "Santa Catarina",
  "Thừa Thiên-Huế",
  "Blagoevgrad Province",
  "Maluku",
  "Ntchisi District",
  "West Dunbartonshire",
  "Gilbert Islands",
  "Saint George Parish",
  "Flevoland",
  "Rotherham",
  "Kavajë District",
  "Mbale District",
  "Girona Province",
  "Paramaribo District",
  "Andaman and Nicobar Islands",
  "Hokkaidō Prefecture",
  "Pará",
  "Brocēni Municipality",
  "New Ireland Province",
  "Kassrine",
  "Molėtai District Municipality",
  "Savanne District",
  "South Karelia",
  "Lạng Sơn",
  "North Karelia",
  "Saint Thomas Parish",
  "Pangasinan",
  "Roche Caiman",
  "Bay Islands Department",
  "Province of Siena",
  "La Pampa",
  "Kénédougou Province",
  "South Hwanghae Province",
  "Saint Thomas Middle Island Parish",
  "Ebonyi State",
  "Jõgeva County",
  "Kaohsiung County",
  "Rivne Oblast",
  "Phú Thọ",
  "French Guiana",
  "Pailin Province",
  "Smith's Parish,",
  "Bhola District",
  "Sheema District",
  "East Azerbaijan Province",
  "Baldone Municipality",
  "Sud-Est",
  "Gamprin",
  "Kėdainiai District Municipality",
  "Chișinău Municipality",
  "Rutana Province",
  "Hadjer-Lamis",
  "Međimurje County",
  "East Macedonia and Thrace",
  "Dundaga Municipality",
  "Ruggell",
  "Koulikoro Region",
  "Wake Island",
  "Tokyo",
  "Minsk Region",
  "Kolonjë District",
  "Bagerhat District",
  "Moulvibazar District",
  "Velike Lašče Municipality",
  "Berry Islands",
  "Diyala Governorate",
  "Rumphi District",
  "Hodonín District",
  "Giurgiu County",
  "Tougué Prefecture",
  "Oplotnica",
  "Shinyanga Region",
  "Katakwi District",
  "Sangha-Mbaéré",
  "Valle del Cauca Department",
  "Jigawa State",
  "Republic of Karelia",
  "Saldus Municipality",
  "Valletta",
  "Nadur",
  "Moray",
  "Taourirt Province",
  "Al Jazirah",
  "Dibër County",
  "Sanaag Region",
  "Karnali Zone",
  "Oldham",
  "Libero consorzio comunale di Caltanissetta",
  "Usulután Department",
  "East Java",
  "Rogašovci Municipality",
  "Pleven Province",
  "Tameside",
  "Dakhla-Oued Ed-Dahab",
  "Labé Prefecture",
  "East Sussex",
  "Metropolitan City of Messina",
  "Agdash District",
  "Ninh Thuận",
  "Jičín District",
  "Pirojpur District",
  "Ayacucho",
  "Comilla District",
  "Đắk Nông",
  "Zalaegerszeg",
  "Corfu Prefecture",
  "Marsaskala",
  "Sud-Bandama",
  "Preveza Prefecture",
  "Al Jawf Governorate",
  "Province of Savona",
  "Västerbotten County",
  "Biliran",
  "Imathia Regional Unit",
  "Olomouc District",
  "Plaines Wilhems District",
  "Jezersko Municipality",
  "Sud-Comoé",
  "Al Muthanna Governorate",
  "Ústí nad Labem District",
  "Tolna County",
  "Bihor County",
  "Stung Treng Province",
  "Maseru District",
  "Nagano Prefecture",
  "Khénifra Province",
  "Santo Domingo de los Tsáchilas Province",
  "Autonomous Region in Muslim Mindanao",
  "Adamawa State",
  "Ascension Island",
  "İzmir Province",
  "Chin State",
  "Canton of Esch-sur-Alzette",
  "Dobrich Province",
  "Manipur",
  "Emilia-Romagna",
  "Harbour Island",
  "Khulna District",
  "Al-Qassim Region",
  "Ciudad Real Province",
  "Kaohsiung",
  "Sa Kaeo",
  "Kwale County",
  "Kurgan Oblast",
  "Alajuela Province",
  "Aklan",
  "Cádiz Province",
  "Covasna County",
  "Mayuge District",
  "Ibb Governorate",
  "Phatthalung",
  "Ariana Governorate",
  "Santa Cruz Province",
  "Klaipėda County",
  "Fukuoka Prefecture",
  "Habiganj District",
  "Taoyuan City",
  "Hưng Yên",
  "Laborie Quarter",
  "Gourma Province",
  "Madhya Pradesh",
  "Province of Sassari",
  "Southern Province",
  "Kedah",
  "Kalimantan",
  "Cayo District",
  "City of Peterborough",
  "Makira-Ulawa Province",
  "Puno",
  "Tarrafal de São Nicolau",
  "Tiaret Province",
  "Neringa Municipality",
  "Zardab District",
  "Jendouba Governorate",
  "Chhattisgarh",
  "Haut-Lomami District",
  "Maluku Islands",
  "Għaxaq",
  "Kazlų Rūda municipality",
  "Phichit",
  "Ainaro Municipality",
  "Vilnius City Municipality",
  "Kafr el-Sheikh Governorate",
  "Northern Ostrobothnia",
  "Presidente Hayes Department",
  "Beheira Governorate",
  "Constantine Province",
  "Náchod District",
  "Udmurt Republic",
  "Eastern Cape",
  "Taichung County",
  "Gornja Radgona Municipality",
  "Baranya County",
  "West Kazakhstan Province",
  "Ilfov County",
  "Walsall",
  "Punjab",
  "Gros Islet Quarter",
  "Sliema",
  "Trang",
  "Anenii Noi District",
  "Central Division",
  "Thaba-Tseka District",
  "Moyle District Council",
  "Ōita Prefecture",
  "Demir Kapija Municipality",
  "Marinduque",
  "Kapchorwa District",
  "Bié Province",
  "Mubarak Al-Kabeer Governorate",
  "Carabobo",
  "Diffa Region",
  "Bradford",
  "Saint Andrew Parish",
  "Ribeira Grande",
  "Phthiotis Prefecture",
  "Sicily",
  "Noonu Atoll",
  "Santa Luċija",
  "Vlorë District",
  "West Herzegovina Canton",
  "Bomi County",
  "Bouenza Department",
  "Akkar Governorate",
  "Cabinda Province",
  "Ang Thong",
  "Honiara",
  "Lazio",
  "Barisal District",
  "Colonia Department",
  "Beyla Prefecture",
  "Antsiranana Province",
  "Eastern Division",
  "Rakai District",
  "Jaffna District",
  "North Caribbean Coast Autonomous Region",
  "Muğla Province",
  "Hauts-de-France",
  "Sơn La",
  "Debarca Municipality",
  "Vuzenica Municipality",
  "Gracias a Dios Department",
  "Raška District",
  "Pomoravlje District",
  "Rize Province",
  "Ulyanovsk Oblast",
  "Sheffield",
  "Kırklareli Province",
  "Anseba Region",
  "Smolyan Province",
  "Ifugao",
  "Herzegovina-Neretva Canton",
  "Lääne-Viru County",
  "Umm Salal Municipality",
  "Médéa Province",
  "Deir ez-Zor Governorate",
  "Wallis and Futuna",
  "Dagana District",
  "Sinaloa",
  "Hhohho District",
  "Luwero District",
  "Balkan Region",
  "Clackmannanshire",
  "Attard",
  "Nickerie District",
  "Amapá",
  "Barinas",
  "Zabul",
  "South Holland",
  "Canton of Schaffhausen",
  "Nsanje District",
  "Kyotera District",
  "Flacq District",
  "Afar Region",
  "Divača Municipality",
  "Tochigi Prefecture",
  "Manawatu-Wanganui Region",
  "Zagreb",
  "Wangdue Phodrang District",
  "Cortés Department",
  "Dedza District",
  "Skuodas District Municipality",
  "Tiznit Province",
  "Ballymoney",
  "Darién Province",
  "Rosoman Municipality",
  "Ogun State",
  "Province of Prato",
  "Da Nang",
  "Derry City Council",
  "Mbarara District",
  "Province of Carbonia-Iglesias",
  "Absheron District",
  "Sacatepéquez Department",
  "Banská Bystrica Region",
  "Bas-Congo province",
  "Bangkok",
  "Rizal",
  "Mongar District",
  "Comoé District",
  "Pesaro and Urbino Province",
  "Addis Ababa",
  "Oregon",
  "Phú Yên",
  "Northern Red Sea Region",
  "Litoměřice District",
  "Matara District",
  "Dadra and Nagar Haveli",
  "Canton of Redange",
  "Sadarak District",
  "Palanga City Municipality",
  "Puconci Municipality",
  "Vevčani Municipality",
  "Faro District",
  "Valparaíso",
  "Saba",
  "Nyeri County",
  "Bistrița-Năsăud County",
  "Vayots Dzor Region",
  "Batticaloa District",
  "Lower Saxony",
  "Faranah Prefecture",
  "Turkestan Region",
  "Ceuta",
  "Emberá-Wounaan Comarca",
  "Boujdour Province",
  "Murmansk Oblast",
  "Boké Prefecture",
  "Kars Province",
  "As-Suwayda Governorate",
  "Prevalje Municipality",
  "Aloja Municipality",
  "Smolensk Oblast",
  "Sveta Ana Municipality",
  "Kep Province",
  "Aswan Governorate",
  "Qinghai",
  "Province of Mantua",
  "Taranaki Region",
  "Madang Province",
  "London Borough of Havering",
  "Sükhbaatar Province",
  "Prešov Region",
  "Písek District",
  "Pirot District",
  "Gjirokastër County",
  "Sarajevo Canton",
  "Vas County",
  "Dhaalu Atoll",
  "Uvs Province",
  "Greater Poland Voivodeship",
  "Bahadia",
  "Saint Paul Capisterre Parish",
  "Río Negro Department",
  "Sveti Jurij ob Ščavnici Municipality",
  "Mayabeque Province",
  "Kagoshima Prefecture",
  "Brda Municipality",
  "Bitola Municipality",
  "Central Bedfordshire",
  "Kouroussa Prefecture",
  "Jakarta",
  "Fukui Prefecture",
  "Province of Rimini",
  "Metropolitan City of Turin",
  "Community of Madrid",
  "Tauragė District Municipality",
  "Utah",
  "Nidwalden",
  "Dolenjske Toplice Municipality",
  "Teleorman County",
  "Ngamiland",
  "Vaupés Department",
  "Požega-Slavonia County",
  "Central Finland",
  "Mtskheta-Mtianeti",
  "Oulu Province",
  "Canton of Remich",
  "Ungheni District",
  "Figuig Province",
  "Nizhny Novgorod Oblast",
  "Mahaica-Berbice",
  "ʻEua",
  "Cesar Department",
  "Nan",
  "Anse la Raye Quarter",
  "Limbazi Municipality",
  "Zonguldak Province",
  "Benishangul-Gumuz Region",
  "Aydın Province",
  "Trzin Municipality",
  "Guainía Department",
  "Haut-Uele",
  "Province of Isernia",
  "Murqub",
  "Kampong Chhnang Province",
  "Amnat Charoen",
  "Maine",
  "Căușeni District",
  "Glarus",
  "Derna District",
  "Vila Real District",
  "Salima District",
  "Oro Province",
  "Leeds",
  "South Lanarkshire",
  "Wokingham",
  "Khövsgöl Province",
  "Takéo Province",
  "Ratanakiri Province",
  "Himachal Pradesh",
  "Yevlakh District",
  "Šumadija District",
  "Ústí nad Orlicí District",
  "Nangarhar",
  "Gevgelija Municipality",
  "Falkirk",
  "Bjelovar-Bilogora County",
  "Finnmark",
  "Västmanland County",
  "Limburg",
  "Khuzestan Province",
  "Thanh Hóa",
  "Province of La Spezia",
  "Canton of Wiltz",
  "Brno-Country District",
  "Hải Dương",
  "Saga Prefecture",
  "Tierra del Fuego Province",
  "Pāvilosta Municipality",
  "Souk Ahras Province",
  "Jizzakh Region",
  "Elgeyo-Marakwet County",
  "Ad Dhahirah Governorate",
  "Mahajanga Province",
  "Xaisomboun Province",
  "Semnan Province",
  "Lampung",
  "Starše Municipality",
  "Kachin State",
  "Yamaguchi Prefecture",
  "Åland Islands",
  "Kalmar County",
  "Lienchiang County",
  "Guanacaste Province",
  "Sopron",
  "Province of Avellino",
  "Amman Governorate",
  "Cotopaxi Province",
  "Bududa District",
  "North East Lincolnshire",
  "Raymah Governorate",
  "Labé Region",
  "Libero consorzio comunale di Agrigento",
  "Tan-Tan Province",
  "Cankuzo Province",
  "Sagarmatha Zone",
  "Zaporizhzhya Oblast",
  "Province of Novara",
  "City of Wolverhampton",
  "Meherpur District",
  "Giza Governorate",
  "Prostějov District",
  "Yasothon",
  "Capital District",
  "Libero consorzio comunale di Siracusa",
  "Far-Western Development Region",
  "Bình Dương",
  "Tuyên Quang",
  "Tartu County",
  "Satakunta",
  "Mazandaran Province",
  "County Donegal",
  "Cross River State",
  "Gramsh District",
  "Aileu municipality",
  "Nouaceur Province",
  "Lugo Province",
  "Western Visayas",
  "Hawalli Governorate",
  "Cluj County",
  "London Borough of Waltham Forest",
  "Trenčín Region",
  "Khouribga Province",
  "Mont Buxton",
  "Saint Mary Parish",
  "Saint George",
  "Saladin Governorate",
  "Xiangkhouang Province",
  "Santiago de Cuba Province",
  "Sancti Spíritus Province",
  "Metlika Municipality",
  "Torfaen",
  "Imishli District",
  "La Union",
  "Olomouc Region",
  "North Yorkshire",
  "O'Higgins",
  "Silesian Voivodeship",
  "Chittagong Division",
  "Vallée du Bandama Region",
  "Unity",
  "Kratié Province",
  "Los Ríos Province",
  "Utena District Municipality",
  "Malanje Province",
  "Beni Department",
  "Makedonski Brod Municipality",
  "Davao Region",
  "Chapai Nawabganj District",
  "Zavrč Municipality",
  "Faetano",
  "Khémisset Province",
  "Una-Sana Canton",
  "Southern Ostrobothnia",
  "Oshana Region",
  "Daşoguz Region",
  "Kursk Oblast",
  "Dohuk Governorate",
  "Leste Province",
  "Veliko Tarnovo Province",
  "Svalbard",
  "Litija Municipality",
  "São Tomé Province",
  "Braga District",
  "Upper Demerara-Berbice",
  "Moyen-Ogooué Province",
  "Priekule Municipality",
  "Ratak Chain",
  "Tozeur Governorate",
  "Zondoma Province",
  "Ryanggang Province",
  "Namur",
  "Liverpool",
  "Pwani Region",
  "Alabama",
  "Poni Province",
  "Plateau State",
  "Maracha District",
  "Rochdale",
  "Kinmen",
  "Province of Sondrio",
  "Uri",
  "Koknese Municipality",
  "Rugāji Municipality",
  "Övörkhangai Province",
  "Ilocos Sur",
  "Kilinochchi District",
  "Katavi Region",
  "Delčevo Municipality",
  "Calabria",
  "Querétaro",
  "Samut Sakhon",
  "Galle District",
  "Sétif Province",
  "Herat",
  "Altai Krai",
  "Taitung County",
  "Kolašin Municipality",
  "Yumbe District",
  "Camagüey Province",
  "Sihanoukville Province",
  "Royal Borough of Greenwich",
  "Cerklje na Gorenjskem Municipality",
  "County Cavan",
  "County Laois",
  "Česká Lípa District",
  "Camarines Sur",
  "Prague 5",
  "Metropolitan City of Genoa",
  "North Bačka District",
  "Benevento Province",
  "Helmand",
  "Cebu",
  "Province of Potenza",
  "Bokeo Province",
  "Lhaviyani Atoll",
  "Independencia",
  "Lielvārde Municipality",
  "London Borough of Bexley",
  "Schleswig-Holstein",
  "Krimulda Municipality",
  "Samaná Province",
  "Petrovec Municipality",
  "České Budějovice District",
  "Mchinji District",
  "Baucau Municipality",
  "Castelo Branco District",
  "Shropshire",
  "Istria County",
  "Jerada Province",
  "Jász-Nagykun-Szolnok County",
  "Tunapuna-Piarco Regional Corporation",
  "Brong-Ahafo Region",
  "South Moravian Region",
  "Xorazm Region",
  "Heilongjiang",
  "Rocha Department",
  "Sánchez Ramírez Province",
  "Sveti Nikole Municipality",
  "Lempira Department",
  "London Borough of Hackney",
  "Angus",
  "Banbridge",
  "Şanlıurfa Province",
  "South Gyeongsang Province",
  "Bunyangabu District",
  "Klaipėda District Municipality",
  "Omsk Oblast",
  "Nana-Mambéré Prefecture",
  "Pays de la Loire",
  "Zacatecas",
  "Plaisance",
  "Lipkovo Municipality",
  "Ennedi-Est",
  "Ñuble Region",
  "Nyanga Province",
  "Peleliu",
  "Metro Manila",
  "Dobrovnik Municipality",
  "Grad Municipality",
  "San Salvador and Rum Cay",
  "Bandundu Province",
  "San Pedro Department",
  "Bong County",
  "Jegunovce Municipality",
  "Extremadura",
  "Bolton",
  "Osh Region",
  "Zaire Province",
  "Fria Prefecture",
  "Preah Vihear Province",
  "Bago",
  "Kuyavian-Pomeranian Voivodeship",
  "Veneto",
  "Beja District",
  "Galați County",
  "Ghardaïa Province",
  "Širvintos District Municipality",
  "Hope Town",
  "Miskolc",
  "Tuzla Canton",
  "Leyte",
  "Provincia de Cartago",
  "Mombasa County",
  "Tamaulipas",
  "Chubut Province",
  "Kompienga Province",
  "Roraima",
  "Luang Namtha Province",
  "Yap State",
  "Maguindanao",
  "Ziguinchor",
  "Lakes",
  "Mai-Ndombe Province",
  "Zarqa Governorate",
  "Mukdahan",
  "Ogooué-Lolo Province",
  "Kuçovë District",
  "Odessa Oblast",
  "Andrijevica Municipality",
  "Khenchela Province",
  "Artibonite",
  "Province of Forlì-Cesena",
  "Province of Olbia-Tempio",
  "Wajir County",
  "Hrastnik Municipality",
  "Oran Province",
  "Imereti",
  "West Kordofan",
  "Guam",
  "Shkodër County",
  "Luxor Governorate",
  "Mehedinți County",
  "Southeast Sulawesi",
  "Saint Joseph Parish",
  "Falcón",
  "Iowa",
  "Santa Elena Province",
  "Pakruojis District Municipality",
  "Laâyoune-Sakia El Hamra",
  "Nimruz",
  "Huesca Province",
  "Dornava Municipality",
  "Singida Region",
  "Okayama Prefecture",
  "Hambantota District",
  "Region of Murcia",
  "Kermanshah Province",
  "Isabela",
  "Gujarat",
  "Cuvette Department",
  "Chiapas",
  "Šentrupert Municipality",
  "Csongrád County",
  "Nichollstown and Berry Islands",
  "Tanganyika Province",
  "Pskov Oblast",
  "Medenine Governorate",
  "Jalisco",
  "London Borough of Tower Hamlets",
  "Scottish Borders",
  "Kaluga Oblast",
  "Akmenė District Municipality",
  "San Salvador Island",
  "Staro Nagoričane Municipality",
  "Réunion",
  "Hsinchu",
  "Mangystau Region",
  "Upper South Province",
  "Harare Province",
  "Adana Province",
  "Nagaland",
  "Warrap",
  "Babylon Governorate",
  "Flemish Brabant",
  "Misamis Occidental",
  "Pader District",
  "Arua District",
  "Virginia",
  "Dhaulagiri Zone",
  "Għasri",
  "Videm Municipality",
  "Mandoul Region",
  "Guangxi Zhuang Autonomous Region",
  "Nakhon Ratchasima",
  "Najaf Governorate",
  "Bedford",
  "Boulgou",
  "Old Royal Capital Cetinje",
  "Dâmbovița County",
  "Western Tobago",
  "Qabala District",
  "Brittany",
  "South Darfur",
  "Central Ostrobothnia",
  "Tetovo Municipality",
  "Bruntál District",
  "Pietà",
  "Līgatne Municipality",
  "Maranhão",
  "Visaginas Municipality",
  "Gagauzia",
  "Tanga Region",
  "Chuquisaca Department",
  "Qrendi",
  "Phetchabun",
  "Moyen-Comoé",
  "Tacna",
  "Buenos Aires Province",
  "Bataan",
  "Zangilan District",
  "Montana Province",
  "Johor",
  "Junín",
  "Songkhla",
  "Vieux Fort Quarter",
  "Bauska Municipality",
  "Misiones Department",
  "Mavrovo and Rostuša Municipality",
  "Šilutė District Municipality",
  "Telšiai District Municipality",
  "Ērgļi Municipality",
  "Cagayan",
  "Gateshead",
  "Fermanagh and Omagh",
  "Cumbria",
  "Erongo Region",
  "Nakhon Sawan",
  "Kalkara",
  "Canton of Lucerne",
  "Serere District",
  "Kvemo Kartli",
  "Assaba Region",
  "Kosovska Mitrovica District",
  "Rogaland",
  "Bicol Region",
  "Berlin",
  "Basarabeasca District",
  "Braničevo District",
  "Nui",
  "San José Department",
  "Al Batinah Region",
  "Akershus",
  "Hauts-Bassins Region",
  "Solihull",
  "Swieqi",
  "Caquetá Department",
  "Shusha District",
  "Uthai Thani",
  "Australian Capital Territory",
  "Postojna Municipality",
  "Šilalė District Municipality",
  "Samsun Province",
  "Brighton and Hove",
  "Sanma",
  "Cibla Municipality",
  "Tororo District",
  "Massachusetts",
  "Hradec Králové Region",
  "Upper Takutu-Upper Essequibo",
  "Coventry",
  "Čučer-Sandevo Municipality",
  "Saint Lucy",
  "Al Jahra Governorate",
  "Mellieħa",
  "Saint-Louis",
  "Chaguanas",
  "Kairouan Governorate",
  "Vaišode Municipality",
  "Nuwara Eliya District",
  "London Borough of Barnet",
  "Pesnica Municipality",
  "Rewa",
  "Dosso Region",
  "Marowijne District",
  "Masovian Voivodeship",
  "Kranjska Gora Municipality",
  "Prahova County",
  "Omagh District Council",
  "Kemps Bay",
  "Kroměříž District",
  "Kirovohrad Oblast",
  "Potosí Department",
  "Royal Borough of Kingston upon Thames",
  "Talas Region",
  "Prague 10",
  "Ewa District",
  "Kishoreganj District",
  "Saulkrasti Municipality",
  "London Borough of Harrow",
  "Casanare Department",
  "Zenica-Doboj Canton",
  "Tyumen Oblast",
  "Osilnica Municipality",
  "Yoro Department",
  "Balaka District",
  "Mojkovac Municipality",
  "Tutong District",
  "Lublin Voivodeship",
  "Rukungiri District",
  "Central Abaco",
  "Żebbuġ Gozo",
  "Canton 10",
  "Ashgabat",
  "Flanders",
  "Chernihiv Oblast",
  "Berat District",
  "Møre og Romsdal",
  "Troms",
  "North Carolina",
  "An Giang",
  "Qakh District",
  "Posavina Canton",
  "Grand Gedeh County",
  "Drâa-Tafilalet",
  "Iganga District",
  "Qashqadaryo Region",
  "Oddar Meanchey Province",
  "County Offaly",
  "Opava District",
  "Elektrėnai municipality",
  "Rychnov nad Kněžnou District",
  "Kasese District",
  "Kiên Giang",
  "Raseiniai District Municipality",
  "Galápagos Province",
  "Babek District",
  "Conakry",
  "Catamarca Province",
  "Yagha Province",
  "Monseñor Nouel Province",
  "North Sumatra",
  "Andijan Region",
  "Turkana County",
  "Stavropol Krai",
  "Amambay Department",
  "Laghman",
  "Šiauliai County",
  "Houaphanh Province",
  "Waikato Region",
  "Devon",
  "Kano State",
  "Rotuma",
  "Baja Verapaz Department",
  "Dumfries and Galloway",
  "Tavastia Proper",
  "Sibiu County",
  "Majšperk Municipality",
  "Dorset",
  "Pakwach District",
  "Paraguarí Department",
  "Yozgat Province",
  "Province of Modena",
  "Apurímac",
  "Lilongwe District",
  "Sarpang District",
  "Mozirje Municipality",
  "Peloponnese Region",
  "Kumi District",
  "Radlje ob Dravi Municipality",
  "Province of Pordenone",
  "Vižinai Municipality",
  "Saint Elizabeth Parish",
  "Oghuz District",
  "Guelmim-Oued Noun",
  "Békés County",
  "Azad Kashmir",
  "Lachin District",
  "Tailevu",
  "Hunedoara County",
  "Daman and Diu",
  "Northern District",
  "Ludza Municipality",
  "Huelva Province",
  "Kyōto Prefecture",
  "Guadalcanal Province",
  "Inchiri Region",
  "Ioannina Regional Unit",
  "Mon State",
  "Bovec Municipality",
  "Rhône-Alpes",
  "Fresh Creek",
  "Hebei",
  "Magway Region",
  "Ica",
  "London Borough of Brent",
  "Vraneštica Municipality",
  "Korçë District",
  "Léraba Province",
  "Dornod Province",
  "Kronoberg County",
  "Ouham Prefecture",
  "Šentjernej Municipality",
  "Northern Borders Region",
  "Trnovska Vas Municipality",
  "Armagh City and District Council",
  "Nyanza Province",
  "Qena Governorate",
  "Bordj Bou Arréridj Province",
  "Tamil Nadu",
  "City of Southampton",
  "Kinshasa",
  "Rhineland-Palatinate",
  "Ozolnieki Municipality",
  "Hajjah Governorate",
  "Mashonaland East Province",
  "Tunceli Province",
  "Mascara Province",
  "Khulna Division",
  "Lovech Province",
  "Liaoning",
  "Puducherry",
  "North Holland",
  "Shanxi",
  "London Borough of Wandsworth",
  "City Municipality of Celje",
  "Pathum Thani",
  "Haut-Sassandra",
  "Kalvarija municipality",
  "Portalegre District",
  "Papua",
  "Schaan",
  "Canton of Vaud",
  "Điện Biên",
  "Chikwawa District",
  "Haskovo Province",
  "Lebap Region",
  "London Borough of Lambeth",
  "Thái Bình",
  "Afyonkarahisar Province",
  "Melaka",
  "Gash-Barka Region",
  "Qormi",
  "Příbram District",
  "São Miguel",
  "Shabran District",
  "Tolima Department",
  "Novo Selo Municipality",
  "Nasarawa State",
  "Dobrna Municipality",
  "Dajabón Province",
  "Salto Department",
  "Akmola Region",
  "Biombo Region",
  "Auvergne",
  "Beqaa Governorate",
  "Camiguin",
  "Cargados Carajos",
  "Namisindwa District",
  "North Kazakhstan Region",
  "Setúbal District",
  "Narayanganj District",
  "Monaragala District",
  "Selangor",
  "Zagorje ob Savi Municipality",
  "Lacs District",
  "Baoruco Province",
  "Győr",
  "Mārupe Municipality",
  "Hawaii",
  "White Nile",
  "Province of Verbano-Cusio-Ossola",
  "Inhambane Province",
  "Qacha's Nek District",
  "Litoral Province",
  "Šalovci Municipality",
  "Koubia Prefecture",
  "Hormozgan Province",
  "Forécariah Prefecture",
  "Ilam Province",
  "Kgalagadi District",
  "Narayani Zone",
  "Eastern Visayas",
  "Straža Municipality",
  "Uttarakhand",
  "Province of Medio Campidano",
  "Eastern Equatoria",
  "canton of Zürich",
  "Lunda Norte Province",
  "Sakhalin",
  "Lai Châu",
  "Żebbuġ Malta",
  "Rivera Department",
  "Pomeroon-Supenaam",
  "Encamp",
  "Tuscany",
  "Roi Et",
  "Kotor Municipality",
  "Carriacou and Petite Martinique",
  "Mendoza",
  "County Roscommon",
  "Razgrad Province",
  "Srem District",
  "Chandpur District",
  "Abia State",
  "Alborz Province",
  "Plzeň Region",
  "Cañar Province",
  "Nueva Vizcaya",
  "Kitgum District",
  "Yên Bái",
  "Batha Region",
  "Nzérékoré Region",
  "Kingman Reef",
  "Rio Grande do Norte",
  "Trashigang District",
  "Rukiga District",
  "Ta' Xbiex",
  "Kırıkkale Province",
  "Sucre Department",
  "Coast Province",
  "Mpumalanga",
  "Manafwa District",
  "Kunar",
  "Banwa Province",
  "Hong Kong",
  "North Gyeongsang Province",
  "Natore District",
  "Nandi District",
  "Vrapčište Municipality",
  "Labuan",
  "Rif Dimashq Governorate",
  "London Borough of Enfield",
  "Al Rayyan Municipality",
  "Brava",
  "Krapina-Zagorje County",
  "Choiseul Quarter",
  "Catalonia",
  "Zhytomyr Oblast",
  "North Sulawesi",
  "North-East District",
  "Rajbari District",
  "Ústí nad Labem Region",
  "Kozje Municipality",
  "Zaragoza Province",
  "Acre",
  "Misiones Province",
  "Manchester Parish",
  "Tabor Municipality",
  "Chuy Region",
  "Tarxien",
  "Julfa District",
  "Plateaux Department",
  "Kostroma Oblast",
  "Mokronog–Trebelno Municipality",
  "Surxondaryo Region",
  "Port Moresby",
  "Veraguas Province",
  "Blackpool",
  "Municipality of Apače",
  "Bushenyi District",
  "Grand Kru County",
  "Hậu Giang",
  "Oyam District",
  "Kémo Prefecture",
  "Chagang Province",
  "Tlaxcala",
  "Trongsa District",
  "Vaitupu",
  "Lamwo District",
  "Fife",
  "Saint John Capisterre Parish",
  "Ben Arous Governorate",
  "Batman Province",
  "Pardubice District",
  "Kisumu County",
  "Zagreb County",
  "Lower Shebelle",
  "Maputo",
  "Masindi District",
  "Darlington",
  "Primorje-Gorski Kotar County",
  "Segovia Province",
  "Toledo Province",
  "Ba",
  "North Down Borough Council",
  "Victoria",
  "Saint Patrick Parish",
  "Brokopondo District",
  "Stockholm County",
  "Kerman Province",
  "Balochistan",
  "Nakhon Si Thammarat",
  "Škofja Loka Municipality",
  "City of Nottingham",
  "Nymburk District",
  "Masvingo Province",
  "Oudalan Province",
  "Jewish Autonomous Oblast",
  "Namangan Region",
  "Khost",
  "Castile and León",
  "County Kildare",
  "Vacoas-Phoenix",
  "Kilis Province",
  "Benguela Province",
  "East Grand Bahama",
  "Gjilan District",
  "Bamako",
  "Ioba Province",
  "Bujumbura Rural Province",
  "Arkhangelsk",
  "Xinjiang",
  "Abra",
  "Province of Livorno",
  "Barda District",
  "Briceni District",
  "Saint Mary Cayon Parish",
  "Shida Kartli",
  "San Luis Potosí",
  "Ujar District",
  "Saint George's Parish",
  "Auvergne-Rhône-Alpes",
  "Shamakhi District",
  "Viana do Castelo District",
  "Msida",
  "Erzurum Province",
  "Río San Juan Department",
  "Ömnögovi Province",
  "Aiga-i-le-Tai",
  "Worcestershire",
  "Ruyigi Province",
  "Malampa",
  "Manica Province",
  "Bushehr Province",
  "Vasilevo Municipality",
  "Chuvash Republic",
  "North East Community Development Council",
  "Micoud Quarter",
  "Valladolid Province",
  "Telemark",
  "Shetland Islands",
  "Sirdaryo Region",
  "Sala Municipality",
  "Saarland",
  "Delhi",
  "Denigomodu District",
  "Osun State",
  "Abidjan",
  "Tébessa Province",
  "Khabarovsk Krai",
  "Mohéli",
  "Florești District",
  "Ali Sabieh Region",
  "Ștefan Vodă District",
  "Nara Prefecture",
  "El Bayadh Province",
  "Blekinge",
  "Marrakesh-Safi",
  "Bioko Norte Province",
  "Kitui County",
  "Železniki Municipality",
  "Vavaʻu",
  "Transnistria autonomous territorial unit",
  "Peqin District",
  "Santa Cruz Department",
  "Centre",
  "Serres Prefecture",
  "Dhofar Governorate",
  "Baghdad Governorate",
  "Žilina Region",
  "Region Zealand",
  "Gorontalo",
  "Guidimaka Region",
  "Matrouh Governorate",
  "Central Bosnia Canton",
  "Butha-Buthe District",
  "Kalangala District",
  "Dagda Municipality",
  "Shiselweni District",
  "Lau",
  "Tel Aviv District",
  "Asyut Governorate",
  "Joniškis District Municipality",
  "Saint Kitts",
  "North Denmark Region",
  "Al Bayda' Governorate",
  "São Filipe",
  "Basel-Landschaft",
  "Vientiane Province",
  "Line Islands",
  "Sumatra",
  "Astara District",
  "Tokushima Prefecture",
  "Boucle du Mouhoun Region",
  "Dravograd Municipality",
  "River Gee County",
  "Soum Province",
  "Pointe-Noire",
  "Dubrovnik-Neretva County",
  "Kilkis Regional Unit",
  "Prague 11",
  "Yamagata Prefecture",
  "Outer Hebrides",
  "Siazan District",
  "Amazonas",
  "Ciego de Ávila Province",
  "Sonsonate Department",
  "Sana'a",
  "Darkhan-Uul Province",
  "Gaafu Alif Atoll",
  "Tumbes",
  "Ismailia Governorate",
  "Central Greece Region",
  "Mohale's Hoek District",
  "Addu Atoll",
  "Sing Buri",
  "Vinica Municipality",
  "Moscow",
  "Kahramanmaraş Province",
  "Nwoya District",
  "Kon Tum",
  "Çankırı Province",
  "Hamburg",
  "Ma'rib Governorate",
  "Skikda Province",
  "Autonomous City Of Buenos Aires",
  "Nuristan",
  "Vrhnika Municipality",
  "Fizuli District",
  "Beroun District",
  "Bourgogne-Franche-Comté",
  "Donga Department",
  "Gaga'emauga",
  "Namayingo District",
  "Télimélé Prefecture",
  "Gabès Governorate",
  "Newfoundland and Labrador",
  "Al-Hasakah Governorate",
  "Otjozondjupa Region",
  "Riau",
  "Nghệ An",
  "Iringa Region",
  "Ngaraard",
  "Sekong Province",
  "Criuleni District",
  "Kyustendil Province",
  "Simiyu Region",
  "N'zi-Comoé",
  "Royal Borough of Kensington and Chelsea",
  "Šmarješke Toplice Municipality",
  "Peć District",
  "Gunma Prefecture",
  "Batangas",
  "Cuyuni-Mazaruni",
  "Metropolitan City of Catania",
  "Aleppo Governorate",
  "Artvin Province",
  "Ouaddaï Region",
  "Saitama Prefecture",
  "Surat Thani",
  "Võru County",
  "Warwickshire",
  "West",
  "Cabañas Department",
  "Chiayi County",
  "Western Highlands Province",
  "Nantou County",
  "Sinop Province",
  "Vologda Oblast",
  "Brunei-Muara District",
  "Malaita Province",
  "Marijampolė County",
  "Neuquén Province",
  "Hradec Králové District",
  "Pasvalys District Municipality",
  "Barlavento Islands",
  "Szabolcs-Szatmár-Bereg County",
  "Lac Region",
  "Maekel Region",
  "Tennessee",
  "Basilan",
  "Moyen-Chari Region",
  "Anjouan",
  "Charlotte Parish",
  "Pirkanmaa",
  "Barbuda",
  "Cundinamarca Department",
  "Chiang Mai",
  "Idaho",
  "Inverclyde",
  "Bukwo District",
  "Maputo Province",
  "La Libertad Department",
  "South-East District",
  "City of Portsmouth",
  "Krasnodar Krai",
  "Shaki District",
  "Barguna District",
  "Davao del Norte",
  "Ayeyarwady Region",
  "Konya Province",
  "Barcelona Province",
  "Arkansas",
  "Hyōgo Prefecture",
  "Prague 7",
  "Chrudim District",
  "Sisak-Moslavina County",
  "Kilifi County",
  "Soriano Department",
  "Lapland",
  "Tabasco",
  "West Pomeranian Voivodeship",
  "Pārgauja Municipality",
  "United States Minor Outlying Islands",
  "Al Ahmadi Governorate",
  "Overijssel",
  "Northland Region",
  "Kef Governorate",
  "Tarragona Province",
  "Saint Michael",
  "Carchi Province",
  "Hampshire",
  "Ningxia Hui Autonomous Region",
  "Ghōr",
  "Libero consorzio comunale di Ragusa",
  "Bilasuvar District",
  "Metropolitan City of Milan",
  "Saint Anne Sandy Point Parish",
  "South Carolina",
  "Komondjari Province",
  "Sinoe County",
  "Zambales",
  "Tirana District",
  "Dauphin Quarter",
  "Escaldes-Engordany",
  "Littoral",
  "Miren–Kostanjevica Municipality",
  "Nakhon Nayok",
  "Trabzon Province",
  "Katsina State",
  "Kotayk Region",
  "Grevena Prefecture",
  "Passoré Province",
  "Jharkhand",
  "Moka District",
  "Adjara",
  "Podlaskie Voivodeship",
  "Montegiardino",
  "Long An",
  "Meta",
  "Cheb District",
  "Madeira",
  "Republic of Khakassia",
  "Kabale District",
  "Khammouane Province",
  "Shumen",
  "Mšarr",
  "Samegrelo-Zemo Svaneti",
  "South Sumatra",
  "Metropolitan City of Venice",
  "Bijelo Polje Municipality",
  "Tabuk Region",
  "Shimane Prefecture",
  "Jablanica District",
  "Sveti Jurij v Slovenskih Goricah Municipality",
  "Karabük Province",
  "Ras al-Khaimah",
  "Engure Municipality",
  "Kupišķis District Municipality",
  "Surrey",
  "Dikhil Region",
  "Retalhuleu Department",
  "Lào Cai",
  "Matabeleland North Province",
  "Southwest",
  "Gambela Region",
  "La Rivière Anglaise",
  "County Louth",
  "Couva-Tabaquite-Talparo Regional Corporation",
  "North Hwanghae Province",
  "Province of Fermo",
  "Warwick Parish",
  "Vilnius District Municipality",
  "Selnica ob Dravi Municipality",
  "Kassala",
  "Portuguesa",
  "Callao",
  "Mladá Boleslav District",
  "Ljubno Municipality",
  "Lower Austria",
  "Mwanza Region",
  "Upper River Division",
  "Plav Municipality",
  "Paola",
  "Gornji Grad Municipality",
  "Prachin Buri",
  "Pabna District",
  "Lääne County",
  "Kandava Municipality",
  "Hodh El Gharbi Region",
  "Prachuap Khiri Khan",
  "Saint Barthélemy",
  "Yala",
  "Bloke Municipality",
  "Tipasa Province",
  "Shiga Prefecture",
  "Sardinia",
  "British Columbia",
  "Musandam Governorate",
  "Neath Port Talbot County Borough",
  "Distrito Nacional",
  "Enugu State",
  "Komenda Municipality",
  "Aghjabadi District",
  "Muramvya Province",
  "Berane Municipality",
  "Ménaka Region",
  "Saint Martin",
  "Aberdeen",
  "Quindío Department",
  "Anse Royale",
  "Central Visayas",
  "Sivas Province",
  "Gorj County",
  "Badulla District",
  "Penal-Debe Regional Corporation",
  "Guárico",
  "Province of Cuneo",
  "Sabah",
  "Buada District",
  "Choiseul Province",
  "Migori County",
  "Zilupe Municipality",
  "Doha",
  "Al Qadarif",
  "Kibuku District",
  "Donetsk Oblast",
  "West Pokot County",
  "Pemagatshel District",
  "Tripura",
  "County Westmeath",
  "Talsi Municipality",
  "Mafeteng District",
  "Islamabad Capital Territory",
  "Republic of Bashkortostan",
  "Belgrade",
  "Bamyan",
  "Province of Lodi",
  "Sukhothai",
  "Bavaria",
  "Otuke District",
  "Port Glaud",
  "Mediouna Province",
  "Dubai",
  "Çorum Province",
  "Tartar District",
  "Adrar Region",
  "Orientale Province",
  "Destrnik Municipality",
  "Mudug",
  "Sežana Municipality",
  "Bafing Region",
  "Caraga",
  "Pita Prefecture",
  "Ararat Province",
  "Kigoma Region",
  "Southern Peninsula Region",
  "Rietavas municipality",
  "Prague 16",
  "Orhei District",
  "Soufrière Quarter",
  "Minsk",
  "Grobiņa Municipality",
  "Khartoum",
  "Schwyz",
  "Agstafa District",
  "East Lothian",
  "Prilep Municipality",
  "Valmiera",
  "Treinta y Tres Department",
  "Toliara Province",
  "Appenzell Innerrhoden",
  "North Somerset",
  "Arizona",
  "Rondônia",
  "Șoldănești District",
  "Chuadanga District",
  "Bryansk Oblast",
  "Alagoas",
  "Vienna",
  "Cova Lima Municipality",
  "Tepelënë District",
  "City Municipality of Novo Mesto",
  "Tovuz District",
  "Meru County",
  "Ashanti Region",
  "Maha Sarakham",
  "Aragua",
  "El Seibo Province",
  "Paktika",
  "Mie Prefecture",
  "canton of Bern",
  "Almaty",
  "Aargau",
  "Washington",
  "Artemisa Province",
  "Laghouat Province",
  "Ribeira Brava Municipality",
  "Guimaras",
  "Liquiçá Municipality",
  "South East Community Development Council",
  "Newtownabbey Borough Council",
  "Kyegegwa District",
  "Oromia Region",
  "Attapeu Province",
  "Lavalleja Department",
  "Kherson Oblast",
  "Heredia Province",
  "Alicante Province",
  "Castries Quarter",
  "Kakheti",
  "Assa-Zag Province",
  "Jiwaka Province",
  "Iwate Prefecture",
  "Çanakkale Province",
  "Ulcinj Municipality",
  "Faridpur District",
  "Vārkava Municipality",
  "West Flanders",
  "Nabatieh Governorate",
  "Sanguié Province",
  "St Helens",
  "Lhuntse District",
  "Nam Định",
  "Dire Dawa",
  "Shirvan",
  "South Cotabato",
  "Saint James Windward Parish",
  "Fejér County",
  "Nyandarua County",
  "Laguna",
  "Udon Thani",
  "Bandarban District",
  "Connacht",
  "Acquaviva",
  "North Lanarkshire",
  "City of London",
  "New Mexico",
  "Tachov District",
  "Al Buraimi Governorate",
  "Hawke's Bay Region",
  "Miranda",
  "Ķekava Municipality",
  "Mubende District",
  "Guéckédou Prefecture",
  "Macenta Prefecture",
  "Călărași District",
  "Prague 12",
  "Podkarpackie Voivodeship",
  "Kent",
  "Uvea",
  "Corsica",
  "Sud-Ouest Region",
  "Radovljica Municipality",
  "Provence-Alpes-Côte d'Azur",
  "Nukufetau",
  "Viqueque Municipality",
  "Jabal al Akhdar",
  "Tavush Region",
  "Nordland",
  "City of Plymouth",
  "La Paz Department",
  "Dabola Prefecture",
  "Malé",
  "Danilovgrad Municipality",
  "Martuni",
  "Racha-Lechkhumi and Kvemo Svaneti",
  "Eastern Highlands Province",
  "Škocjan Municipality",
  "Batna Province",
  "Guanajuato",
  "Ilinden Municipality",
  "Stara Zagora Province",
  "City of Stoke-on-Trent",
  "Adjumani District",
  "Haa Alif Atoll",
  "East Darfur",
  "River Cess County",
  "Karak Governorate",
  "Bas-Sassandra Region",
  "Bonaire",
  "Jerash Governorate",
  "Phoenix Islands",
  "Khatlon Province",
  "Anzoátegui",
  "Noakhali District",
  "Békéscsaba",
  "Maryland County",
  "South Governorate",
  "Kukës District",
  "Espírito Santo",
  "Escuintla Department",
  "Gyeonggi Province",
  "Ahal Region",
  "Aberdeenshire",
  "Gaga'ifomauga",
  "Province of Barletta-Andria-Trani",
  "Vojvodina",
  "Kalasin",
  "Alta Verapaz Department",
  "Utrecht",
  "El Oued Province",
  "Alsace",
  "Ventspils",
  "Lomaiviti",
  "Gazipur District",
  "Rhode Island",
  "Mogila Municipality",
  "Blue Nile",
  "Karbinci",
  "Salyan District",
  "Mqabba",
  "Magadan Oblast",
  "Luqa",
  "Sahel Region",
  "Al Farwaniyah Governorate",
  "Teleneşti District",
  "Friesland",
  "Amuru District",
  "Chichaoua Province",
  "Burgos Province",
  "Monte Plata Province",
  "West Sussex",
  "Pristina (Prishtine)",
  "Zamboanga Sibugay",
  "Loei",
  "Damietta Governorate",
  "Delaware",
  "Domažlice District",
  "Stann Creek District",
  "Moroto District",
  "Shabwah Governorate",
  "Centar Municipality",
  "Gulf",
  "Dobje Municipality",
  "Chimbu Province",
  "Centre-Nord Region",
  "Saraj Municipality",
  "Yaroslavl Oblast",
  "Beltinci Municipality",
  "Lesser Poland Voivodeship",
  "Govi-Altai Province",
  "Federal Capital Territory",
  "Niigata Prefecture",
  "Melilla",
  "Tadjourah Region",
  "Dunaújváros",
  "Cuvette-Ouest Department",
  "Lumbini Zone",
  "Chai Nat",
  "Praia",
  "Saint Ann Parish",
  "Tauragė County",
  "Upper Normandy",
  "Las Palmas Province",
  "Northumberland",
  "County Monaghan",
  "Saratov Oblast",
  "County Mayo",
  "Province of Campobasso",
  "Western Division",
  "Hiroshima Prefecture",
  "Veržej Municipality",
  "Albacete Province",
  "Lopburi",
  "Ravne na Koroškem Municipality",
  "Staffordshire",
  "Fergana Region",
  "Grand Cay",
  "Guayas Province",
  "Hakkâri Province",
  "Chachoengsao",
  "Zamboanga del Norte",
  "Iğdır Province",
  "Lahij Governorate",
  "Bakool",
  "Northern Governorate",
  "Les Mamelles",
  "Chitipa district",
  "County Clare",
  "Saskatchewan",
  "Zaječar District",
  "Saint Andrew",
  "Shkodër District",
  "Bohol",
  "Republic of Adygea",
  "Yardymli District",
  "Keelung",
  "Samdrup Jongkhar District",
  "Portland Parish",
  "Marsabit County",
  "Cookstown District Council",
  "Skrīveri Municipality",
  "Tearce Municipality",
  "Koper City Municipality",
  "Mačva District",
  "Žužemberk Municipality",
  "Ribeira Grande de Santiago",
  "Jēkabpils",
  "Saint Peter Parish",
  "Savannakhet Province",
  "Basse-Kotto Prefecture",
  "Viesīte Municipality",
  "Chefchaouen Province",
  "Šenčur Municipality",
  "Finland Proper",
  "Baringo County",
  "London Borough of Camden",
  "Tamanghasset Province",
  "Roja Municipality",
  "Kouritenga Province",
  "Northern Division",
  "Kindia Region",
  "Podunavlje District",
  "Los Lagos Region",
  "Yalova Province",
  "Kocaeli Province",
  "Nairobi",
  "Ralik Chain",
  "Balqa Governorate",
  "Plungė District Municipality",
  "Metropolitan City of Cagliari",
  "Rennell and Bellona Province",
  "Kardzhali Province",
  "Rakovník District",
  "Socotra Governorate",
  "Leinster",
  "Selenge Province",
  "Bagmati Zone",
  "Bahr el Gazel",
  "South Bačka District",
  "County Limerick",
  "Iklin",
  "Shirak Region",
  "Zambezia Province",
  "'Amran Governorate",
  "Agdam District",
  "Rače–Fram Municipality",
  "Guatemala Department",
  "Ha'il Region",
  "Ceredigion",
  "Vidin Province",
  "Paphos District",
  "East Berbice-Corentyne",
  "Bà Rịa-Vũng Tàu",
  "Fălești District",
  "Amolatar District",
  "Choluteca Department",
  "Province of Massa and Carrara",
  "Namosi",
  "Karbala Governorate",
  "Senglea",
  "Buvuma District",
  "Baalbek-Hermel Governorate",
  "Kyankwanzi District",
  "Moravske Toplice Municipality",
  "Province of Parma",
  "Sannat",
  "Kostel Municipality",
  "Minnesota",
  "Varakļāni Municipality",
  "Bahia",
  "Dudley",
  "Taoudénit Region",
  "Chechen Republic",
  "Vysočina Region",
  "Torbay",
  "Pljevlja Municipality",
  "Guairá Department",
  "Thimphu District",
  "Kandahar",
  "Ombella-M'Poko Prefecture",
  "Serravalle",
  "Mwaro Province",
  "Ouarzazate Province",
  "Vavuniya District",
  "Kuldīga Municipality",
  "Derry City and Strabane",
  "Vargas",
  "North Bank Division",
  "Norrbotten County",
  "Mokhotlong District",
  "Kédougou",
  "Tete Province",
  "Quiché Department",
  "Uttar Pradesh",
  "Mizoram",
  "Saint John",
  "Mahdia Governorate",
  "Hatay Province",
  "Luapula Province",
  "Casablanca-Settat",
  "Šentilj Municipality",
  "North Dakota",
  "South Eleuthera",
  "Province of Ogliastra",
  "Dix-Huit Montagnes",
  "Blaenau Gwent County Borough",
  "Liepāja",
  "Volta Region",
  "Jönköping County",
  "Napo Province",
  "Renče-Vogrsko Municipality",
  "Ouest",
  "Cibitoke Province",
  "Laikipia County",
  "Šoštanj Municipality",
  "Najran Region",
  "Kalutara District",
  "Vakaga Prefecture",
  "Cuscatlán Department",
  "Fahs Anjra Province",
  "Qusar District",
  "Koh Kong Province",
  "Strakonice District",
  "Lower Silesian Voivodeship",
  "Cheshire East",
  "Inezgane-Aït Melloul Prefecture",
  "Potaro-Siparuni",
  "Drama Regional Unit",
  "Kalungu District",
  "Paget Parish",
  "Pursat Province",
  "Durango",
  "Pinar del Río Province",
  "Peravia Province",
  "Demir Hisar Municipality",
  "Baltinava Municipality",
  "Zaghouan Governorate",
  "Kuala Lumpur",
  "Down District Council",
  "Herefordshire",
  "Murzuq District",
  "Moxico Province",
  "County Kilkenny",
  "Tarlac",
  "City and County of Cardiff",
  "Granada Department",
  "Hà Giang",
  "Hà Tĩnh",
  "Province of Ascoli Piceno",
  "Saada Governorate",
  "Muscat Governorate",
  "Henan",
  "Markovci Municipality",
  "Butambala District",
  "Medway",
  "Turnišče Municipality",
  "Odisha",
  "Kurdamir District",
  "Córdoba Province",
  "Gostivar Municipality",
  "Palauli",
  "Kurigram District",
  "Tainan",
  "Aqaba Governorate",
  "Buri Ram",
  "Butebo District",
  "Sirajganj District",
  "Gornji Petrovci Municipality",
  "Northern Mariana Islands",
  "Paraná",
  "Borovnica Municipality",
  "Farah",
  "Kayseri Province",
  "Nilphamari District",
  "Rokycany District",
  "Kaunas District Municipality",
  "Red Sea",
  "Suffolk",
  "Coimbra District",
  "Wallonia",
  "Antrim",
  "Birgu",
  "New Valley Governorate",
  "Jaén Province",
  "Patuakhali District",
  "Saint Lawrence",
  "Veracruz",
  "Kénitra Province",
  "Mdina",
  "Bukomansimbi District",
  "East Attica Regional Unit",
  "Somogy County",
  "Orellana Province",
  "Zeeland",
  "Sousse Governorate",
  "Borkou",
  "Zanjan Province",
  "Sughd Province",
  "Souss-Massa",
  "Ballymena Borough",
  "Rapla County",
  "Province of Varese",
  "Sîngerei District",
  "Central Department",
  "Središče ob Dravi",
  "Kohgiluyeh and Boyer-Ahmad Province",
  "Puerto Plata Province",
  "Saint John Figtree Parish",
  "Prague 4",
  "Solčava Municipality",
  "Oppland",
  "Erbil Governorate",
  "Diourbel Region",
  "Đồng Tháp",
  "Bali",
  "Břeclav District",
  "Bangui",
  "Pomeranian Voivodeship",
  "Tukums Municipality",
  "Atyrau Region",
  "Inčukalns Municipality",
  "Saraburi",
  "South Tyneside",
  "Halton",
  "Amhara Region",
  "Jerusalem District",
  "Zou Department",
  "Madona Municipality",
  "Kiruhura District",
  "Gao Region",
  "Canton of St. Gallen",
  "England",
  "Tashkent",
  "Ormož Municipality",
  "Province of Vicenza",
  "Connecticut",
  "Al Daayen",
  "Carinthia",
  "Zelenikovo Municipality",
  "Tehran Province",
  "Oslo",
  "Balkh",
  "Jujuy Province",
  "Kabardino-Balkar Republic",
  "Ljutomer Municipality",
  "Boké Region",
  "County Galway",
  "Marijampolė Municipality",
  "Doncaster",
  "London Borough of Richmond upon Thames",
  "Tartus Governorate",
  "Southend-on-Sea",
  "Belfast district",
  "Adrar Province",
  "Wyoming",
  "Attica Region",
  "Queensland",
  "Logone Occidental Region",
  "Almaty Region",
  "Varėna District Municipality",
  "Grenadines Parish",
  "Salford",
  "Gomel Region",
  "Sefton",
  "Kogi State",
  "Braila",
  "Shaanxi",
  "La Rioja",
  "Soria Province",
  "Mat District",
  "Hamilton Parish",
  "Mayo-Kebbi Ouest Region",
  "Minya Governorate",
  "Grand'Anse Mahé",
  "Nador Province",
  "Province of Asti",
  "Ganzourgou Province",
  "Ilūkste Municipality",
  "Guerrero",
  "Manouba Governorate",
  "Canindeyú",
  "Piura",
  "Mambéré-Kadéï",
  "El Tarf Province",
  "Ghanzi District",
  "Babīte Municipality",
  "Cuenca Province",
  "Liège",
  "Fujian",
  "Western Province",
  "Tropojë District",
  "Bazèga Province",
  "Kanagawa Prefecture",
  "Au Cap",
  "Ehime Prefecture",
  "Kranj City Municipality",
  "Khagrachari District",
  "Trentino-South Tyrol",
  "Kalbajar District",
  "Bioko Sur Province",
  "Penza Oblast",
  "Pärnu County",
  "Novosibirsk",
  "Krasnoyarsk Krai",
  "Brahmanbaria District",
  "Eastern Province",
  "Vladimir Oblast",
  "Badakhshan",
  "Črensovci Municipality",
  "Berkane Province",
  "Surin",
  "Koundara Prefecture",
  "Gradsko Municipality",
  "Hermanas Mirabal Province",
  "Jalapa Department",
  "Aguascalientes",
  "Banteay Meanchey Province",
  "Trnava Region",
  "Kagadi District",
  "Westfjords",
  "Oum El Bouaghi Province",
  "Jeju",
  "Jan Mayen",
  "Križevci Municipality",
  "Saint Helena",
  "Drenthe",
  "Bouïra Province",
  "Gisborne District",
  "Beni Suef Governorate",
  "Madaripur District",
  "Huancavelica",
  "Latakia Governorate",
  "Blackburn with Darwen",
  "Drochia District",
  "Taraba State",
  "South Australia",
  "Nitra Region",
  "Essex",
  "Krustpils Municipality",
  "Cerro Largo Department",
  "Xagħra",
  "Santa Fe Province",
  "Ma'an Governorate",
  "Federal Dependencies of Venezuela",
  "Lola Prefecture",
  "Sveta Trojica v Slovenskih Goricah Municipality",
  "Granada Province",
  "Gabú Region",
  "Nonthaburi",
  "Northern Ireland",
  "Bilecik Province",
  "North Kalimantan",
  "Zaqatala District",
  "Kosrae State",
  "Viseu District",
  "Radenci Municipality",
  "Corinthia Regional Unit",
  "Schellenberg",
  "São Paulo",
  "London Borough of Barking and Dagenham",
  "Funafuti",
  "Franche-Comté",
  "Štore Municipality",
  "Hòa Bình",
  "Pest County",
  "Düzce Province",
  "Quirino",
  "Rîșcani District",
  "Ostrava-City District",
  "City of Derby",
  "Grand Cape Mount County",
  "Prague 14",
  "Kumamoto Prefecture",
  "Mityana District",
  "Jijel Province",
  "Saint Catherine Parish",
  "Tissemsilt Province",
  "Östergötland County",
  "Kadavu",
  "Province of Cremona",
  "Bubanza Province",
  "Centre-Val de Loire",
  "Kemerovo Oblast",
  "Gasa District",
  "Mashonaland Central Province",
  "Kasungu District",
  "Lwengo District",
  "Province of Matera",
  "Faiyum Governorate",
  "Sulawesi",
  "Est Region",
  "Kiambu County",
  "Žiri Municipality",
  "Cat Island",
  "Šuto Orizari Municipality",
  "Makole Municipality",
  "Vorarlberg",
  "Kičevo Municipality",
  "Fianarantsoa Province",
  "Balıkesir Province",
  "West Grand Bahama",
  "Batken Region",
  "Siquijor",
  "Larnaca District",
  "Republic of Tatarstan",
  "Alebtong District",
  "Thurgau",
  "San Marcos Department",
  "Lija",
  "Šmartno pri Litiji Municipality",
  "Noumbiel Province",
  "West Bačka District",
  "Jesenice Municipality",
  "Phang Nga",
  "Warrington",
  "North Lincolnshire",
  "South Andros",
  "Gorgol Region",
  "Kirinyaga County",
  "Cēsis Municipality",
  "Bimini",
  "Olancho Department",
  "Moscow Oblast",
  "Biskra",
  "Quebec",
  "Punakha District",
  "Central Banat District",
  "Kibaale District",
  "Ninh Bình",
  "Nicosia District",
  "Inagua",
  "Ogooué-Maritime Province",
  "Aichi Prefecture",
  "Pehčevo Municipality",
  "Pampanga",
  "Volyn Oblast",
  "Bayan-Ölgii Province",
  "Sucre",
  "El Jadida Province",
  "Slovenske Konjice Municipality",
  "Beau Bassin-Rose Hill",
  "Argyll and Bute",
  "Norte Province",
  "Al-Shahaniya",
  "South Pyongan Province",
  "Mtarfa",
  "Bamingui-Bangoran Prefecture",
  "Fukushima Prefecture",
  "Bacău County",
  "Denguélé District",
  "Kwilu District",
  "Central Kalimantan",
  "Kukës County",
  "Bogovinje Municipality",
  "London Borough of Merton",
  "San Luis Province",
  "Nový Jičín District",
  "Petnjica Municipality",
  "Windsor and Maidenhead",
  "Gwynedd",
  "Ape Municipality",
  "Province of Nuoro",
  "Cunene Province",
  "Jēkabpils Municipality",
  "Siparia Regional Corporation",
  "Flores Department",
  "South Bohemian Region",
  "Djibouti",
  "Brod-Posavina Canton",
  "Colima",
  "Nampula Province",
  "Agago District",
  "Čair Municipality",
  "Santiago Metropolitan Region",
  "Northern Territory",
  "Tindouf Province",
  "Misamis Oriental",
  "Havlíčkův Brod District",
  "Krujë District",
  "Sistan and Baluchestan",
  "Jinotega Department",
  "Lyantonde District",
  "Province of Catanzaro",
  "Dolneni Municipality",
  "Idlib Governorate",
  "Tanintharyi Region",
  "Temotu Province",
  "Košice Region",
  "Cochabamba Department",
  "Kamphaeng Phet",
  "Southern Region",
  "Hardap Region",
  "Luxembourg",
  "Munshiganj District",
  "Picardy",
  "Limpopo",
  "Hualien County",
  "Grosuplje Municipality",
  "El Hajeb Province",
  "Njombe Region",
  "Split-Dalmatia County",
  "Meghalaya",
  "Kankan Prefecture",
  "Sakha Republic",
  "Dhi Qar Governorate",
  "Taiwan Province, People's Republic of China",
  "Feni District",
  "Province of Latina",
  "Durrës County",
  "Varna Province",
  "Saint James Parish",
  "Atakora Department",
  "Salaspils Municipality",
  "Lalmonirhat District",
  "Pallisa District",
  "Lozovo Municipality",
  "Quảng Bình",
  "Kunduz Province",
  "Chittagong District",
  "Phongsaly Province",
  "Pointe La Rue",
  "Dingli",
  "Terengganu",
  "Puebla",
  "Granma Province",
  "Ankaran Municipality",
  "Pivka Municipality",
  "Ngora District",
  "Obwalden",
  "North Andros",
  "Lankaran District",
  "Virovitica-Podravina County",
  "Kumanovo Municipality",
  "Nadroga-Navosa",
  "Cornwall",
  "East Flanders",
  "Algiers Province",
  "Cabo Delgado Province",
  "Ngöbe-Buglé Comarca",
  "Western Region",
  "Antique",
  "Arequipa",
  "Studeničani Municipality",
  "Damascus Governorate",
  "Ionian Islands Region",
  "Metropolitan Borough of Wigan",
  "Saïda Province",
  "Florida Department",
  "Embu County",
  "Van Province",
  "Kiboga District",
  "Zrnovci Municipality",
  "Hesse",
  "Timiș County",
  "Grand Bassa County",
  "Piedmont",
  "Northwestern Province",
  "Boyacá Department",
  "Al Khor",
  "Saatly District",
  "Morelos",
  "Kilimanjaro Region",
  "Cordillera Department",
  "Machakos County",
  "Sultan Kudarat",
  "Kladno District",
  "Voronezh Oblast",
  "Toplica District",
  "Sangre Grande Regional Corporation",
  "Ntungamo District",
  "Gabrovo Province",
  "Normandy",
  "Andhra Pradesh",
  "Triesenberg",
  "Navarre",
  "Nouvelle-Aquitaine",
  "Sabaragamuwa Province",
  "Jonava District Municipality",
  "Siirt Province",
  "Alaska",
  "Busia District",
  "Province of Crotone",
  "Meneng District",
  "Kirkop",
  "Niari Department",
  "Arunachal Pradesh",
  "Mārsrags Municipality",
  "Iecava Municipality",
  "Sourou Province",
  "Gilgit-Baltistan",
  "Penghu County",
  "Rangpur Division",
  "Bury",
  "Tsirang District",
  "Tafilah Governorate",
  "Settat Province",
  "Gnagna Province",
  "Rayong",
  "Kayangel",
  "Bulqizë District",
  "Bulawayo Province",
  "Province of Brescia",
  "Lisburn City Council",
  "Nevada",
  "Merthyr Tydfil County Borough",
  "Nottinghamshire",
  "West Greece Region",
  "Pasco",
  "Lisbon District",
  "Nenets Autonomous Okrug",
  "New Jersey",
  "North Province",
  "Bua",
  "Agusan del Norte",
  "Nariño Department",
  "Azores",
  "Nugal",
  "Fier District",
  "Mullaitivu District",
  "León Department",
  "Buliisa District",
  "Balearic Islands",
  "Upper West Region",
  "Glacis",
  "Cheshire West and Chester",
  "Vaslui County",
  "Oklahoma",
  "Ñeembucú Department",
  "Tunis Governorate",
  "Savanes Region",
  "Mirna Municipality",
  "Áncash",
  "Amuria District",
  "Žabljak Municipality",
  "Jaunpils Municipality",
  "Bolívar Department",
  "Abu Dhabi Emirate",
  "City of Kingston upon Hull",
  "East Kalimantan",
  "High Rock",
  "Sliven Province",
  "Cankova Municipality",
  "Cauca Department",
  "Mid-Western Region",
  "Province of Teramo",
  "Kurbin District",
  "Perak",
  "Entre Ríos Province",
  "Carazo Department",
  "León Province",
  "Nong Khai",
  "Kymenlaakso",
  "Stockport",
  "Naklo Municipality",
  "Abyan Governorate",
  "Blansko District",
  "Rift Valley Province",
  "Şırnak Province",
  "Marsa",
  "Qala",
  "Madrid Province",
  "Bizerte Governorate",
  "Vilnius County",
  "Epirus Region",
  "Atlantique Department",
  "Dowa District",
  "Rabat",
  "Vojnik Municipality",
  "Wadi Fira Region",
  "Vinnytsia Oblast",
  "Belize District",
  "Riau Islands",
  "Sikkim",
  "Ijuw District",
  "Kebili Governorate",
  "Irbid Governorate",
  "Vihiga District",
  "Probištip Municipality",
  "Ivano-Frankivsk Oblast",
  "Uíge Province",
  "Southampton Parish",
  "Valle Department",
  "Gandaki Zone",
  "Calabarzon",
  "Zakarpattia Oblast",
  "Ostrobothnia",
  "Republic of Buryatia",
  "Zhemgang District",
  "North Rhine-Westphalia",
  "West Papua",
  "Newcastle upon Tyne",
  "Haʻapai",
  "Veszprém",
  "Ohio",
  "Ganja",
  "Sejong City",
  "Cienfuegos Province",
  "Province of Perugia",
  "Viljandi County",
  "Negros Oriental",
  "Centre-Est Region",
  "Ocnița District",
  "Santarém District",
  "Quthing District",
  "Planken",
  "Northern Region",
  "Hà Tây",
  "Davao Occidental",
  "Panamá Oeste Province",
  "Georgia",
  "Scotland",
  "Pattani",
  "District of Columbia",
  "Daykundi",
  "Manabí Province",
  "Kainuu",
  "Irkutsk",
  "Chaco Province",
  "Tapoa Province",
  "Province of Pistoia",
  "Khentii Province",
  "Ladakh",
  "Kamnik Municipality",
  "Champagne-Ardenne",
  "Caraș-Severin County",
  "Taipei",
  "Dashkasan District",
  "Nord-Ouest",
  "Gedo",
  "West Nusa Tenggara",
  "Northeastern Region",
  "Yunnan",
  "Tizi Ouzou Province",
  "Nord-Est",
  "Prienai District Municipality",
  "Ohrid Municipality",
  "Taraclia District",
  "Kwango District",
  "A Coruña Province",
  "Ubon Ratchathani",
  "South Abaco",
  "Hela",
  "Edineț District",
  "Marj District",
  "Kungota",
  "Hadhramaut Governorate",
  "London Borough of Bromley",
  "Larissa Prefecture",
  "Halland County",
  "Northamptonshire",
  "Chernivtsi Oblast",
  "Province of Imperia",
  "Nikšić Municipality",
  "Mitooma District",
  "Wales",
  "Orkhon Province",
  "Zhejiang",
  "Benghazi",
  "Yamalo-Nenets Autonomous Okrug",
  "Baker Island",
  "Ouham-Pendé Prefecture",
  "Santiago Rodríguez Province",
  "Jelgava",
  "Kidričevo Municipality",
  "Umbria",
  "Nunavut",
  "Tibet Autonomous Region",
  "Dobrova–Polhov Gradec Municipality",
  "Niğde Province",
  "Cuanza Norte Province",
  "Fier County",
  "Kočani Municipality",
  "Antananarivo Province",
  "Nelson Region",
  "West Lothian",
  "Ennedi Region",
  "Jabal al Gharbi District",
  "Daejeon",
  "Federally Administered Tribal Areas",
  "Kaunas City Municipality",
  "Pembrokeshire",
  "Antioquia Department",
  "Jelgava Municipality",
  "Vestfold",
  "Izola Municipality",
  "Teplice District",
  "Kossi Province",
  "Ibaraki Prefecture",
  "Araucanía Region",
  "Ocotepeque Department",
  "Demerara-Mahaica",
  "Prague 9",
  "Caldas Department",
  "Champasak Province",
  "Daegu",
  "Zinder Region",
  "Milne Bay Province",
  "Valencian Community",
  "Miyazaki Prefecture",
  "Masaya Department",
  "Knowsley",
  "Midway Atoll",
  "Satkhira District",
  "Taita–Taveta County",
  "Trakai District Municipality",
  "North Tyneside",
  "Republic of Mordovia",
  "Alexandria Governorate",
  "Zreče Municipality",
  "Zawiya District",
  "La Romana Province",
  "North Brabant",
  "Trinity Palmetto Point Parish",
  "Kouilou Department",
  "Kérouané Prefecture",
  "Mali Prefecture",
  "Monastir Governorate",
  "Shariatpur District",
  "Bạc Liêu",
  "Nereta Municipality",
  "Paktia",
  "Bolu Province",
  "Kretinga District Municipality",
  "Dobrepolje Municipality",
  "Los Ríos Region",
  "Western Bahr el Ghazal",
  "Lubombo District",
  "Żurrieq",
  "Sar-e Pol",
  "La Guajira Department",
  "Saint Luke Parish",
  "South Sulawesi",
  "Nouakchott-Ouest Region",
  "South Kordofan",
  "'Asir Region",
  "Chomutov District",
  "Brvenica Municipality",
  "Bosnian Podrinje Canton",
  "Kavango West Region",
  "County Durham",
  "Prince Edward Island",
  "Pella Regional Unit",
  "Province of Chieti",
  "Šakiai District Municipality",
  "Friuli–Venezia Giulia",
  "Vĩnh Phúc",
  "Temburong District",
  "Province of Treviso",
  "Saint Louis",
  "Kostanjevica na Krki Municipality",
  "Birmingham",
  "Al Hudaydah Governorate",
  "Lika-Senj County",
  "Suphanburi",
  "Goiás",
  "Aetolia-Acarnania Regional Unit",
  "Kirklees",
  "Cakaudrove",
  "London Borough of Hounslow",
  "Bengo Province",
  "Carnikava Municipality",
  "Zlín District",
  "Dundee",
  "Kočevje Municipality",
  "Powys",
  "Kurdistan Province",
  "Mengeš Municipality",
  "Trentino",
  "Phrae",
  "Suceava County",
  "Bucharest",
  "Uppsala County",
  "Khmelnytsky Oblast",
  "Sud",
  "Osijek-Baranja County",
  "Moulay Yacoub Province",
  "Lankaran",
  "Aysén Region",
  "Sulu",
  "Chelyabinsk Oblast",
  "Ljubljana City Municipality",
  "Semič Municipality",
  "Shamkir District",
  "Porto Novo",
  "Razavi Khorasan Province",
  "Ohangwena Region",
  "Hajigabul District",
  "Amazonas Department",
  "Province of Brindisi",
  "Greater Skopje",
  "Relizane Province",
  "Central Eleuthera",
  "Yamanashi Prefecture",
  "Haa Dhaalu Atoll",
  "Kiev",
  "Wrexham County Borough",
  "Slough",
  "Ben Slimane Province",
  "Bukedea District",
  "Denbighshire",
  "Nazarje Municipality",
  "Highland",
  "Nana-Grébizi Economic Prefecture",
  "Buskerud",
  "Republic of Ingushetia",
  "Semily District",
  "West Java",
  "Capiz",
  "Tolmin Municipality",
  "Quba District",
  "Bugiri District",
  "Michigan",
  "Agusan del Sur",
  "Negros Occidental",
  "Jabrayil District",
  "Aragatsotn Region",
  "Isiolo County",
  "Druskininkai municipality",
  "Kamuli District",
  "Glodeni District",
  "Oryol Oblast",
  "Kasaï District",
  "Tata Province",
  "Lorestan Province",
  "Chiradzulu District",
  "Luxembourg District",
  "Ida-Viru County",
  "Resen Municipality",
  "Ourense Province",
  "Quảng Ngãi",
  "Suchitepéquez Department",
  "Mersin Province",
  "Limassol District",
  "Mukono District",
  "Niuas",
  "Bracknell Forest",
  "Canton of Echternach",
  "Bosilovo Municipality",
  "Namutumba District",
  "Santander Department",
  "Kavadarci Municipality",
  "Phetchaburi",
  "Lusaka Province",
  "Nišava District",
  "Yambol Province",
  "Rēzekne",
  "Imbabura Province",
  "Cojedes",
  "Centre-Ouest Region",
  "Safi Province",
  "Kirov Oblast",
  "Awdal Region",
  "Saint James",
  "Akita Prefecture",
  "Chlef Province",
  "Zanzan Region",
  "Alif Alif Atoll",
  "Tuy Province",
  "Nakaseke District",
  "Wiltshire",
  "Tây Ninh",
  "Budaka District",
  "Hódmezővásárhely",
  "Al Hoceïma Province",
  "Jafara",
  "Quintana Roo",
  "Matale District",
  "Kanem Region",
  "Kruševac Municipality",
  "Bình Phước",
  "Sefrou Province",
  "Nyíregyháza",
  "Lima",
  "Bay",
  "Eastern Tobago",
  "Dhaka Division",
  "South Pemba Region",
  "Uroševac District (Ferizaj)",
  "Togdheer Region",
  "Christ Church",
  "Jihlava District",
  "Lancashire",
  "South Gloucestershire",
  "Kushtia District",
  "Birżebbuġa",
  "Ħamrun",
  "Kaberamaido District",
  "Monagas",
  "Walloon Brabant",
  "Moravian-Silesian Region",
  "Jinja District",
  "Iași County",
  "Jiangxi",
  "San José de Ocoa Province",
  "Klaipeda City Municipality",
  "Apulia",
  "Isle of Wight",
  "Gansu",
  "Lanao del Norte",
  "North Kivu",
  "Sidi Youssef Ben Ali",
  "Jonglei State",
  "Šmartno ob Paki Municipality",
  "Medvode Municipality",
  "Táchira",
  "Cáceres Province",
  "Đắk Lắk",
  "Luče Municipality",
  "Makedonska Kamenica Municipality",
  "Sangha Department",
  "Nueva Ecija",
  "Province of Trieste",
  "Kayunga District",
  "Aquitaine",
  "Bắc Kạn",
  "Diego Martin Regional Corporation",
  "Nkhotakota District",
  "Putumayo Department",
  "Brezovica Municipality",
  "Province of Udine",
  "Kajiado County",
  "Ilocos Norte",
  "Province of Taranto",
  "Renfrewshire",
  "Grevenmacher District",
  "Newport",
  "Coronie District",
  "Värmland County",
  "Szeged",
  "Jindřichův Hradec District",
  "Aïn Defla Province",
  "Battambang Province",
  "Tržič Municipality",
  "Rēzekne Municipality",
  "Nayarit",
  "Meemu Atoll",
  "San José Province",
  "Béni Mellal-Khénifra",
  "Samut Songkhram",
  "Vilkaviškis District Municipality",
  "Faafu Atoll",
  "Macuata",
  "Mopti Region",
  "Kotido District",
  "North West",
  "Jhenaidah District",
  "Napak District",
  "Bar Municipality",
  "Riga",
  "Lipetsk Oblast",
  "Bel Air",
  "Češinovo-Obleševo Municipality",
  "Shtouka Ait Baha Province",
  "Homa Bay County",
  "Libero consorzio comunale di Enna",
  "Oyo State",
  "Amasya Province",
  "City of Sunderland",
  "Paysandú Department",
  "Lesser Sunda Islands",
  "Faryab",
  "Sergipe",
  "Muharraq Governorate",
  "Metropolitan City of Bologna",
  "Idrija Municipality",
  "Lefkada Regional Unit",
  "Balvi Municipality",
  "Port Said Governorate",
  "Samut Prakan",
  "Quảng Nam",
  "Shaviyani Atoll",
  "Southern Leyte",
  "Denguélé Region",
  "Lukovica Municipality",
  "Governor's Harbour",
  "Örebro County",
  "Kisoro District",
  "Comayagua Department",
  "Nagykanizsa",
  "West Coast Division",
  "Trans-Nzoia District",
  "Rostov Oblast",
  "Point Fortin",
  "Kelmė District Municipality",
  "Basque Country",
  "Kampong Speu Province",
  "Cà Mau",
  "Guria",
  "Badghis",
  "Yamoussoukro",
  "Northern Cape",
  "Tbilisi",
  "Martinique",
  "Székesfehérvár",
  "Albay",
  "Province of Rieti",
  "Jablonec nad Nisou District",
  "Riebiņi Municipality",
  "Ogooué-Ivindo Province",
  "Province of L'Aquila",
  "Līvāni Municipality",
  "Dokolo District",
  "Pukë District",
  "Cairo Governorate",
  "Aizpute Municipality",
  "Tangail District",
  "Krabi",
  "West Virginia",
  "Tshuapa District",
  "Baden-Württemberg",
  "Yevlakh",
  "Kingston Parish",
  "Limón Province",
  "Enga Province",
  "Cambridgeshire",
  "Hubei",
  "Prague 15",
  "Central Andros",
  "Shizuoka Prefecture",
  "Sulaymaniyah Governorate",
  "Lleida Province",
  "Rubirizi District",
  "Daugavpils",
  "Rakhine State",
  "Diyarbakır Province",
  "Caerphilly County Borough",
  "Rason",
  "Causeway Coast and Glens",
  "Al Anbar Governorate",
  "Järva County",
  "Agaléga",
  "Bulgan Province",
  "Chukha District",
  "Madre de Dios",
  "Rūjiena Municipality",
  "Tuamasaga",
  "Littoral Department",
  "City and County of Swansea",
  "Nukulaelae",
  "Pernambuco",
  "Munster",
  "Province of Grosseto",
  "Tokat Province",
  "Bratislava Region",
  "Juršinci Municipality",
  "Canillo",
  "Hsinchu County",
  "Carrickfergus Borough Council",
  "Maradi Region",
  "Ratnapura district",
  "Bumthang District",
  "Tashkent Region",
  "Shanghai",
  "Fatick",
  "Bor District",
  "Ghat District",
  "Missouri",
  "Uaboe District",
  "Canton of Luxembourg",
  "Al Haouz Province",
  "Los Santos Province",
  "Cordillera Administrative Region",
  "Bến Tre",
  "Sigave",
  "Province of Ancona",
  "Pazardzhik Province",
  "Clarendon Parish",
  "Matam",
  "American Samoa",
  "Samarqand Region",
  "Curepipe",
  "Gulbene Municipality",
  "Province of Cosenza",
  "Southern Savonia",
  "Trutnov District",
  "Libero consorzio comunale di Trapani",
  "Chatham Islands",
  "Al Jawf Region",
  "Mirna Peč Municipality",
  "Aïn Témouchent Province",
  "M'Sila Province",
  "Karviná District",
  "Central Singapore Community Development Council",
  "Al Wusta Governorate",
  "Velika Polana Municipality",
  "Sumy Oblast",
  "Colón Department",
  "Chandigarh",
  "Kidal Region",
  "Edinburgh",
  "Arcadia Prefecture",
  "Chihuahua",
  "West Berkshire",
  "Quảng Trị",
  "Radeče Municipality",
  "Havana Province",
  "Bari",
  "districts of Republican Subordination",
  "Strășeni District",
  "Hamilton Municipality",
  "Upper Nile",
  "Saint Peter",
  "Rumonge Province",
  "Lovrenc na Pohorju Municipality",
  "Nanumea",
  "Piauí",
  "Nuevo León",
  "Antofagasta Region",
  "Antwerp",
  "Metropolitan City of Bari",
  "Kolín District",
  "Cavite",
  "Nippes",
  "Balé Province",
  "Naypyidaw Union Territory",
  "North Western Province",
  "Baja California",
  "Villa Clara Province",
  "Newry and Mourne District Council",
  "Boa Vista",
  "Pedernales Province",
  "Sevastopol",
  "Nord-Ubangi District",
  "Bingöl Province",
  "Žďár nad Sázavou District",
  "Bolívar",
  "Karnataka",
  "Gaafu Dhaalu Atoll",
  "Province of Ferrara",
  "Sumqayit",
  "Prachatice District",
  "Laamu Atoll",
  "Sylhet Division",
  "Woleu-Ntem Province",
  "North Governorate",
  "London Borough of Islington",
  "Risaralda Department",
  "Chongqing",
  "Brazzaville",
  "Madinat ash Shamal",
  "Karas Region",
  "Lubāna Municipality",
  "Anse-aux-Pins",
  "Canton of Fribourg",
  "'Adan Governorate",
  "Borgou Department",
  "Santa Venera",
  "Izabal Department",
  "Soccsksargen",
  "Pastaza Province",
  "Antalya Province",
  "Erzincan Province",
  "Kaabong District",
  "Putrajaya",
  "Guna Yala",
  "Lofa County",
  "Al Wahat District",
  "Bobonaro Municipality",
  "Pahang",
  "Kigali district",
  "Haryana",
  "Apayao",
  "Ribnica na Pohorju Municipality",
  "Telšiai County",
  "Freeport",
  "Luhansk Oblast",
  "Province of Macerata",
  "Mimaropa",
  "Mykolaiv Oblast",
  "Western Area",
  "Mae Hong Son",
  "Errachidia Province",
  "Republic of North Ossetia-Alania",
  "N'Djamena",
  "Huehuetenango Department",
  "Đakovica District (Gjakove)",
  "Aerodrom Municipality",
  "Svay Rieng Province",
  "Sant Julià de Lòria",
  "Omaheke Region",
  "Busia County",
  "Managua Department",
  "Isles of Scilly",
  "Chimborazo Province",
  "Arauca Department",
  "Northern Bahr el Ghazal",
  "Ķegums Municipality",
  "Kangarli District",
  "North Eastern Province",
  "Annaba Province",
  "Autonomous Republic of Crimea",
  "Muchinga Province",
  "Lezhë County",
  "Satu Mare County",
  "Naama Province",
  "Ulster",
  "Karlovy Vary Region",
  "Kanal ob Soči Municipality",
  "Príncipe Province",
  "Nyamira District",
  "Alto Paraguay Department",
  "Telford and Wrekin",
  "Kaišiadorys District Municipality",
  "Ngatpang",
  "Žalec Municipality",
  "Central Darfur",
  "Harghita County",
  "Quinara Region",
  "Incheon",
  "Luuka District",
  "Kavango East Region",
  "Stirling",
  "São Domingos",
  "Argolis Regional Unit",
  "Ajdovščina Municipality",
  "Netrokona District",
  "Municipality of Ilirska Bistrica",
  "Karpoš Municipality",
  "Mbomou Prefecture",
  "Hîncești District",
  "Moyen-Cavally",
  "Viļaka Municipality",
  "Djelfa Province",
  "Šiauliai City Municipality",
  "Pamplemousses District",
  "Alba",
  "Takamaka",
  "Lékoumou Department",
  "Chocó Department",
  "Moravica District",
  "Pennsylvania",
  "Ibanda District",
  "Omusati Region",
  "Hato Mayor Province",
  "Salavan Province",
  "Mérida",
  "Nord",
  "Vransko Municipality",
  "Acklins",
  "Capital Region",
  "Penang",
  "South",
  "Southern Nations, Nationalities, and Peoples' Region",
  "Nova Scotia",
  "Braslovče Municipality",
  "Imo State",
  "Oued Ed-Dahab Province",
  "Kefalonia Prefecture",
  "Upper East Region",
  "Blantyre District",
  "Lobaye Prefecture",
  "Tana River County",
  "Vukovar-Syrmia County",
  "Campeche",
  "Benue State",
  "San Martín",
  "Preiļi Municipality",
  "Delvinë District",
  "Coleraine Borough Council",
  "Ondo State",
  "Louny District",
  "Greater Accra Region",
  "Cesvaine Municipality",
  "Sonora",
  "Bistrica ob Sotli Municipality",
  "United Kingdom",
  "Nakhchivan Autonomous Republic",
  "Central Sulawesi",
  "Long Island",
  "North Central Province",
  "Valverde Province",
  "West Sumatra",
  "Tver Oblast",
  "Province of Monza and Brianza",
  "Pontevedra Province",
  "Thessaloniki Regional Unit",
  "Santa Cruz de Tenerife Province",
  "North Ayrshire",
  "Bács-Kiskun County",
  "Silistra Province",
  "Kagawa Prefecture",
  "Khovd Province",
  "Ağrı Province",
  "Luanda Province",
  "Mary Region",
  "Gia Lai",
  "Denizli Province",
  "Goranboy District",
  "Ticino",
  "Southern Highlands Province",
  "Oslomej Municipality",
  "Għargħur",
  "Targovishte Province",
  "Río Muni",
  "Štip Municipality",
  "Munxar",
  "Al Bahah Region",
  "Palmyra Atoll",
  "Copperbelt Province",
  "Västernorrland County",
  "Phalombe District",
  "Smiltene Municipality",
  "Metropolitan City of Florence",
  "Prague 2",
  "Seville Province",
  "Kharkiv Oblast",
  "Likoma District",
  "Chiba Prefecture",
  "Tasmania",
  "Dolj County",
  "Chiang Rai",
  "Trbovlje Municipality",
  "Hajdú-Bihar County",
  "Basilicata",
  "Saint Paul Charlestown Parish",
  "Siaya County",
  "Cospicua",
  "Naukšēni Municipality",
  "County Longford",
  "Boffa Prefecture",
  "Gudja",
  "Tétouan Province",
  "Cuando Cubango Province",
  "Leribe District",
  "Tomsk Oblast",
  "Ribnica Municipality",
  "Central Equatoria",
  "Beylagan District",
  "Hartlepool",
  "Baiti District",
  "Qazakh District",
  "Kapisa",
  "Narail District",
  "Sandwell",
  "Quảng Ninh",
  "Sēja Municipality",
  "Uusimaa",
  "Republika Srpska",
  "Okinawa Prefecture",
  "Paul",
  "Nūca Municipality",
  "Anabar District",
  "Zabaykalsky Krai",
  "Hama Governorate",
  "Yunlin County",
  "Nahouri Province",
  "London Borough of Ealing",
  "Pool Department",
  "Lambayeque",
  "La Digue",
  "Central Luzon",
  "Black Point",
  "North West Community Development Council",
  "Krāslava Municipality",
  "Ryazan Oblast",
  "Zoundwéogo Province",
  "North Khorasan Province",
  "Jambyl Region",
  "Negotino Municipality",
  "Centrale Region",
  "Bulambuli District",
  "Campania",
  "Norfolk",
  "Itapúa",
  "Saint Mark Parish",
  "Jambi",
  "Sharur District",
  "Bungoma County",
  "Kerala",
  "County Wicklow",
  "Fès-Meknès",
  "Xgħajra",
  "Guantánamo Province",
  "Has District",
  "Jūrmala",
  "Kiryandongo District",
  "Bururi Province",
  "Cajamarca",
  "Panevėžys City Municipality",
  "Lamphun",
  "Morobe Province",
  "La Rioja Province",
  "Valka Municipality",
  "Boquerón Department",
  "Goa",
  "Strabane District Council",
  "Karditsa Regional Unit",
  "Chalatenango Department",
  "City of Westminster",
  "Santiago Province",
  "Eger",
  "Päijänne Tavastia",
  "Wadi al Shatii District",
  "Třebíč District",
  "Bay of Plenty Region",
  "Triesen",
  "Ouargla Province",
  "Hedmark",
  "Alibori Department",
  "Agsu District",
  "Zajas Municipality",
  "Jammu and Kashmir",
  "Istanbul Province",
  "Tlemcen Province",
  "Naitasiri",
  "Central District",
  "Lautém Municipality",
  "Siguiri Prefecture",
  "Northern Samar",
  "Primorsky Krai",
  "Boeotia Regional Unit",
  "Metropolitan City of Reggio Calabria",
  "Veles Municipality",
  "Midlands Province",
  "Las Tunas Province",
  "Minas Gerais",
  "Évora District",
  "Tarapacá Region",
  "Laško Municipality",
  "Rum Cay District",
  "Manyara Region",
  "Canton of Vianden",
  "Nakasongola District",
  "London Borough of Croydon",
  "Dakar",
  "Hodh Ech Chargui Region",
  "Garissa County",
  "Bitlis Province",
  "Ziro Province",
  "Rajshahi Division",
  "Michoacán",
  "Ngardmau",
  "Vĩnh Long",
  "Bishkek",
  "Ash Sharqiyah North Governorate",
  "Worodougou",
  "West Azarbaijan Province",
  "Dubăsari District",
  "Vale of Glamorgan",
  "Mara Region",
  "Mardin Province",
  "Province of Caserta",
  "Kindia Prefecture",
  "Hiiu County",
  "Kampala District",
  "Cantabria",
  "London Borough of Sutton",
  "South Kivu",
  "Kerċem",
  "Tainan County",
  "South Central Province",
  "Samukh District",
  "Baie Sainte Anne",
  "Alytus City Municipality",
  "Sal",
  "Butel Municipality",
  "Loška Dolina Municipality",
  "North",
  "Lakshmipur District",
  "Aragon",
  "Bath and North East Somerset",
  "Kankan Region",
  "Ruvuma Region",
  "Gbarpolu County",
  "Sandys Parish",
  "Limousin",
  "Borgo Maggiore",
  "Bogra District",
  "Cerkno Municipality",
  "Saint Joseph",
  "Sunamganj District",
  "Kericho County",
  "Southern Governorate",
  "Al Wakrah",
  "North Banat District",
  "Jalilabad District",
  "Gampaha District",
  "Mpigi District",
  "Liguria",
  "Toyama Prefecture",
  "Kufra District",
  "Sint Eustatius",
  "Malësi e Madhe District",
  "Haut-Mbomou Prefecture",
  "Ngeremlengui",
  "Kütahya Province",
  "Elazığ Province",
  "West Coast Region",
  "Ragged Island",
  "Altai Republic",
  "Sveti Tomaž Municipality",
  "Kié-Ntem Province",
  "Chimaltenango Department",
  "Kayin State",
  "Šavnik Municipality",
  "Kriva Palanka Municipality",
  "Kyzylorda Region",
  "Konče Municipality",
  "Hoče–Slivnica Municipality",
  "Al-Raqqah Governorate",
  "Dondușeni District",
  "Goygol District",
  "Trat",
  "Kırşehir Province",
  "Yazd Province",
  "Hajdina Municipality",
  "Kween District",
  "Khyber Pakhtunkhwa",
  "Tasman District",
  "Somerset",
  "Uva Province",
  "Federation of Bosnia and Herzegovina",
  "Canton of Clervaux",
  "Zombo District",
  "Tafea",
  "Pogradec District",
  "Saint Paul Parish",
  "A'ana",
  "Province of Pescara",
  "Garkalne Municipality",
  "Lâm Đồng",
  "Sohag Governorate",
  "Mallakastër District",
  "Kasaï-Oriental",
  "Aktobe Region",
  "Hanover Parish",
  "Gifu Prefecture",
  "Tshopo District",
  "Birštonas Municipality",
  "Kolda",
  "Horjul Municipality",
  "Alto Paraná Department",
  "Zagora Province",
  "Švenčionys District Municipality",
  "Ilocos Region",
  "Santa Ana Department",
  "Ignalina District Municipality",
  "Perm Krai",
  "Mtwara Region",
  "Mingachevir",
  "Orange Walk District",
  "Marahoué Region",
  "County Tipperary",
  "Dobele Municipality",
  "María Trinidad Sánchez Province",
  "Andorra la Vella",
  "Budapest",
  "San Salvador Department",
  "West Sulawesi",
  "Ségou Region",
  "Vratsa Province",
  "Santa Bárbara Department",
  "Zamfara State",
  "Rogaška Slatina Municipality",
  "Apac District",
  "Dnipropetrovsk Oblast",
  "Tharaka Nithi County",
  "San Miguel Department",
  "Mulanje District",
  "Ituri Interim Administration",
  "Metropolitan City of Rome",
  "Plzeň‑South District",
  "Moquegua",
  "Bujumbura Mairie Province",
  "South Khorasan Province",
  "South Ayrshire",
  "Vaʻa-o-Fonoti",
  "Arkhangai Province",
  "Ogre Municipality",
  "Berovo Municipality",
  "Tambacounda Region",
  "Famagusta District",
  "County Sligo",
  "Puntarenas Province",
  "Ouémé Department",
  "Sassandra‑Marahoué District",
  "Sonsorol",
  "Vitanje Municipality",
  "Middle Shebelle",
  "Province of Ravenna",
  "Arusha Region",
  "Paris",
  "Aimeliik",
  "Paro District",
  "Debrecen",
  "Saint George's Municipality",
  "Črna na Koroškem Municipality",
  "Batanes",
  "Espaillat Province",
  "Tulcea County",
  "Mountain Province",
  "Plateau‑Central Region",
  "Tula Oblast",
  "Lushnjë District",
  "Balzers",
  "Karonga District",
  "Kalinga",
  "Trelawny Parish",
  "Torba",
  "Bío Bío Region",
  "Alif Dhaal Atoll",
  "Isabel Province",
  "Esmeraldas",
  "Northwestern Region",
  "Camarines Norte",
  "Nógrád County",
  "Isparta Province",
  "Balzan",
  "Madaba Governorate",
  "Sédhiou",
  "Styria",
  "Eschen",
  "Durrës District",
  "Rasina District",
  "Urozgan",
  "Kanchanaburi",
  "Znojmo District",
  "Berea District",
  "Mzimba District",
  "México",
  "Budva Municipality",
  "Larache Province",
  "Maribor City Municipality",
  "Guadeloupe",
  "Oxfordshire",
  "Ankara Province",
  "Győr‑Moson‑Sopron County",
  "Province of Como",
  "Perlis",
  "Sila Region",
  "Sandaun Province",
  "Béchar Province",
  "Suez Governorate",
  "County Carlow",
  "Tottori Prefecture",
  "Azilal Province",
  "Republic of Dagestan",
  "Durbe Municipality",
  "Pembroke Parish",
  "Warmian‑Masurian Voivodeship",
  "Dalarna County",
  "Pichincha Province",
  "Nisporeni District",
  "Bukidnon",
  "Prague 13",
  "Nebbi District",
  "Saint Peter Basseterre Parish",
  "Province of Viterbo",
  "Aveiro District",
  "Baghlan",
  "Lagunes District",
  "Azua Province",
  "Province of Frosinone",
  "Nova Gorica City Municipality",
  "Žirovnica Municipality",
  "Khomas Region",
  "Cascades Region",
  "Buhweju District",
  "Muyinga Province",
  "Jeseník District",
  "Salamat Region",
  "Naryn Region",
  "Dubréka Prefecture",
  "Mato Grosso do Sul",
  "Kakamega County",
  "Vlorë County",
  "Dili Municipality",
  "Tungurahua Province",
  "Isfahan Province",
  "Palawan",
  "Biscay",
  "Haiphong",
  "Bender Municipality",
  "Mostaganem Province",
  "Christ Church Nichola Town Parish",
  "Province of Verona",
  "Sissili Province",
  "Kyrenia District",
  "Durazno Department",
  "Prey Veng Province",
  "Lara",
  "Tirana County",
  "Gipuzkoa",
  "Gombe State",
  "Kirkuk Governorate",
  "Ishikawa Prefecture",
  "Équateur",
  "Eastern Finland Province",
  "Montserrado County",
  "Barisal Division",
  "Kaunas County",
  "Zanzibar North Region",
  "Trà Vinh",
  "Taʿizz Governorate",
  "Mari El Republic",
  "Gaoual Prefecture",
  "Phuket",
  "Baikonur",
  "Dol pri Ljubljani Municipality",
  "San Áwann",
  "Piran Municipality",
  "Andalusia",
  "Colombo District",
  "Thyolo District",
  "Ranong",
  "Cerkvenjak Municipality",
  "Si Sa Ket",
  "Benešov District",
  "Bauchi State",
  "Rutland",
  "Louga",
  "Province of Pavia",
  "Saramacca District",
  "Reading",
  "Assam",
  "Insular Region",
  "Podgorica Municipality",
  "Appenzell Ausserrhoden",
  "Kyiv Oblast",
  "Zala County",
  "Dibër District",
  "Port Louis",
  "Grande Comore",
  "Sherpur District",
  "Boulemane Province",
  "Santa Cruz",
  "Krivogaštani Municipality",
  "Bogdanci Municipality",
  "Kebbi State",
  "Belgorod Oblast",
  "Mulţ Province",
  "Derbyshire",
  "Gorišnica Municipality",
  "Thái Nguyên",
  "Pyongyang",
  "Phra Nakhon Si Ayutthaya",
  "Novgorod Oblast",
  "Kwara State",
  "Kayah State",
  "Coquimbo Region",
  "Manitoba",
  "Prague‑West District",
  "Pelhřimov District",
  "Duarte Province",
  "Librazhd District",
  "Euboea",
  "Grand Est",
  "Province of Terni",
  "Nibok District",
  "Province of Belluno",
  "Gomba District",
  "Coyah Prefecture",
  "Ash Sharqiyah South Governorate",
  "Hiran",
  "Prague 3",
  "Guadalajara Province",
  "Plateaux Region",
  "Oriental Mindoro",
  "Montagnes District",
  "Rivière Noire District",
  "Šibenik‑Knin County",
  "St. Julian's",
  "Misrata District",
  "Vecumnieki Municipality",
  "Central Region",
  "Vaduz",
  "Ngarchelong",
  "Heves County",
  "Manus Province",
  "Žetale Municipality",
  "Quneitra Governorate",
  "Bayburt Province",
  "Province of Lucca",
  "Sóc Trăng",
  "Huíla Province",
  "East Kazakhstan Region",
  "Satupa'itea",
  "Guangdong",
  "Hainaut",
  "Tombouctou Region",
  "North‑West District",
  "Kagera Region",
  "Magellan and the Chilean Antarctic Region",
  "Yomou Prefecture",
  "Orenburg Oblast",
  "Geita Region",
  "Coclé Province",
  "Galguduud",
  "Kabul",
  "Tanger‑Tétouan‑Al Hoceïma",
  "Province of Reggio Emilia",
  "Razkrižje Municipality",
  "Yerevan",
  "Monte Cristi Province",
  "Mount Lebanon Governorate",
  "Birkirkara",
  "Drugovo Municipality",
  "Mangochi District",
  "Valga County",
  "Morona‑Santiago Province",
  "Province of Oristano",
  "Gżira",
  "Sanmatenga Province",
  "Middlesbrough",
  "East Riding of Yorkshire",
  "Annobón Province",
  "Samburu County",
  "Groningen",
  "Zomba District",
  "Lindi Region",
  "Sarangani",
  "Alberta",
  "Tibesti Region",
  "Kastamonu Province",
  "Vaavu Atoll",
  "Nagasaki Prefecture",
  "Diekirch District",
  "Castlereagh",
  "Ääska Municipality",
  "La Unión Department",
  "Tucumán Province",
  "Botoşani County",
  "Bursa Province",
  "Pagėgiai Municipality",
  "Makamba Province",
  "Baku",
  "Brno‑City District",
  "Dodoma Region",
  "Nord Region, Burkina Faso",
  "Umm al‑Quwain",
  "Floriana",
  "Tērvete Municipality",
  "Chania Regional Unit",
  "Utena County",
  "Intibucá Department",
  "Atua",
  "San Fernando",
  "Louisiana",
  "Dhamar Governorate",
  "Dinajpur District",
  "Kourwéogo Province",
  "Liberec Region",
  "Ordubad District",
  "Eastern Samar",
  "Northwest",
  "Biržai District Municipality",
  "El Progreso Department",
  "Airai",
  "Ngchesar",
  "Agadez Region",
  "Bắc Ninh",
  "San Marino",
  "Homs Governorate",
  "Nakuru District",
  "East New Britain",
  "Surigao del Norte",
  "Ardahan Province",
  "Colorado",
  "Jowzjan",
  "Manufahi Municipality",
  "Gaibandha District",
  "Tarrafal",
  "Shahbuz District",
  "Praslin Quarter",
  "Kisii County",
  "Mazsalaca Municipality",
  "Dakahlia Governorate",
  "Podlehnik Municipality",
  "Burgundy",
  "Šmarje pri Jelšah Municipality",
  "Île‑de‑France",
  "Vecpiebalga Municipality",
  "Mažeikiai District Municipality",
  "Liberec District",
  "Azuay Province",
  "Přerov District",
  "Ampara District",
  "City of York",
  "Makueni County",
  "Osh",
  "Hunan",
  "Gilan Province",
  "Dennery Quarter",
  "Kaliningrad",
  "Far North",
  "Kostanay Region",
  "Plužine Municipality",
  "Ialomița County",
  "Salamanca Province",
  "Málaga Province",
  "Tekirdağ Province",
  "Macau",
  "Tandjilé Region",
  "San Juan‑Laventille Regional Corporation",
  "Niutao Island Council",
  "Hertfordshire",
  "Busan",
  "Serua",
  "North Kordofan",
  "Province of Foggia",
  "New Hampshire",
  "Ialoveni District",
  "County Cork",
  "Sokolov District",
  "Huánuco",
  "Lélouma Prefecture",
  "Cotabato",
  "Red Sea Governorate",
  "Chiesanuova",
  "Bougainville",
  "Ajman Emirate",
  "Sanaʽa Governorate",
  "Bocas del Toro Province",
  "Canton of Solothurn",
  "Bragança District",
  "Northern Province",
  "Tongatapu",
  "Logone Oriental Region",
  "El Oro Province",
  "Sfax Governorate",
  "Karlovy Vary District",
  "Maysan Governorate",
  "Gangwon Province",
  "Jizan Region",
  "Northern",
  "Pčinja District",
  "County Wexford",
  "Grand Port District",
  "Taounate Province",
  "Masbate",
  "County Waterford",
  "Sakarya Province",
  "Córdoba Department",
  "Pohnpei State",
  "Molise",
  "Abruzzo",
  "Kozani Prefecture",
  "Mymensingh Division",
  "Ceará",
  "Chiayi City",
  "North Hamgyong Province",
  "North Eleuthera",
  "Canton of Valais",
  "Kielce",
  "Benedikt Municipality",
  "Sembabule District",
  "Canton of Diekirch",
  "Shaki",
  "Mid Ulster",
  "Otago Region",
  "Koboko District",
  "Haute‑Kotto Prefecture",
  "Miaoli County",
  "Murcia Province",
  "Guizhou",
  "South Sinai Governorate",
  "Mexico City",
  "Dar es Salaam Region",
  "Koror",
  "Gwangju",
  "Phnom Penh",
  "Tak",
  "South Hamgyong Province",
  "Canelones Department",
  "Kasaï‑Occidental",
  "Kunene Region",
  "Municipality of Škofljica",
  "Sololá Department",
  "Devonshire Parish",
  "Valencia Province",
  "Haut‑Katanga Province",
  "Břežice Municipality",
  "Lazdijai District Municipality",
  "Lagos",
  "Corrientes",
  "Dhaka District",
  "Issyk‑Kul Region",
  "KwaZulu‑Natal",
  "Plovdiv Province",
  "Trarza Region",
  "Ash Sharqiyah Region",
  "Komi Republic",
  "Telangana",
  "Southern Red Sea Region",
  "Sipaliwini District",
  "Omoro District",
  "Sironko District",
  "Sofia City Province",
  "Artigas Department",
  "Taichung",
  "Zlín Region",
  "Lower River Division",
  "Neamț County",
  "Kampong Cham Province",
  "Ahuachapán Department",
  "Raa Atoll",
  "Rukwa Region",
  "Khon Kaen",
  "New Brunswick",
  "Ouaka Prefecture",
  "Yatenga Province",
  "Gôh‑Djiboua District",
  "La Altagracia Province",
  "Bougouriba Province",
  "Érd",
  "Benguet",
  "Gorno‑Badakhshan Autonomous Province",
  "Kosi Zone",
  "Estuaire Province",
  "Anse Boileau",
  "Sharjah Emirate",
  "Bình Thuận",
  "Ho Chi Minh City",
  "Montana",
  "Põlva County",
  "Arad County",
  "Ordu Province",
  "Marsh Harbour",
  "Buckinghamshire",
  "Colón Province",
  "Anetan District",
  "Amudat District",
  "Wakefield",
  "Comoé Province",
  "Languedoc‑Roussillon",
  "Al‑Qādisiyyah Governorate",
  "Lendava Municipality",
  "Mosta",
  "West Bengal",
  "Barahona Province",
  "Prague 21",
  "Canton of Grevenmacher",
  "Chinandega Department",
  "Tuva Republic",
  "North Pemba Region",
  "Mymensingh District",
  "Kaliro District",
  "Manchester",
  "Għajnsielem",
  "Constanța County",
  "Jaunpiebalga Municipality",
  "Elbasan County",
  "Saint Thomas",
  "Northwest Territories",
  "Sikasso Region",
  "Zlatibor District",
  "Mayotte",
  "Centro Sur Province",
  "Phayao",
  "Carmarthenshire",
  "Mondulkiri Province",
  "Chaharmahal and Bakhtiari Province",
  "Plaviš Municipality",
  "Oshikoto Region",
  "South Caribbean Coast Autonomous Region",
  "Wanica District",
  "Upper Austria",
  "São Vicente",
  "Debub Region",
  "South Chungcheong Province",
  "Centar Župa Municipality",
  "Trøndelag",
  "Muta Municipality",
  "Midlothian",
  "Mandalay Region",
  "Fa'asaleleaga",
  "Ruse Province",
  "Dinagat Islands",
  "Morogoro Region",
  "Occidental Mindoro",
  "City of Bristol",
  "Nueva Esparta",
  "Kaduna State",
  "Vichada Department",
  "Makkah Region",
  "Kole District",
  "Parwan",
  "Vaisigano",
  "Kentucky"
];
